// Spanish UI dictionary — generated 2026-06, neutral international "usted" tone.
export const translationsEs = {
  "nav.home": "Inicio",
  "nav.about": "Acerca de",
  "nav.support": "Ayuda",
  "nav.privacy": "Privacidad",
  "nav.virtueguide": "Virtue Guide",
  "nav.newsletter": "Boletín",
  "newsletter.cta.title": "El boletín de StoicOs.ai",
  "newsletter.cta.intro": "Sabiduría estoica práctica, nuevos artículos de Living Library y reflexiones de Academy — cuidadosamente enviados. Sin spam; puede darse de baja en cualquier momento.",
  "newsletter.cta.button": "Recibir el boletín",
  "newsletter.cta.close": "Cerrar",
  "home.frieze": "CONÓCETE A TI MISMO",
  "home.my.title": "Cree gratis su My StoicOs",
  "home.my.intro": "My StoicOs es su espacio personal dentro de la Stoa.",
  "home.my.access": "Su cuenta gratuita le da acceso a:",
  "home.my.b1": "su entorno personal de aprendizaje",
  "home.my.b2": "Academy",
  "home.my.b3": "The Stoic Journal",
  "home.my.b4": "Living Library",
  "home.my.b5": "los mentores estoicos",
  "home.my.b6": "sus reflexiones guardadas",
  "home.my.b7": "su progreso de aprendizaje",
  "home.my.b8": "sincronización entre StoicOs.ai y la aplicación Virtue Guide",
  "home.my.secure": "Todo se guarda de forma segura para que pueda continuar su camino dentro de la Stoa en cualquier dispositivo.",
  "home.my.cta": "Crear mi StoicOs gratis",
  "home.discover.title": "¿Le gustaría descubrir más primero?",
  "home.discover.intro1": "Cada camino comienza de una manera distinta.",
  "home.discover.intro2": "Quizá desee primero descubrir la historia de la Stoa o explorar con mayor profundidad la filosofía estoica.",
  "home.discover.agora.title": "Quisiera saber más sobre los estoicos",
  "home.discover.agora.body": "Descubra cómo la Stoa se desarrolló a lo largo de más de 2.300 años, desde Zenón de Citio hasta Marco Aurelio.",
  "home.discover.agora.cta": "Visitar Agora",
  "home.discover.journal.title": "Quisiera leer más sobre la filosofía estoica",
  "home.discover.journal.body": "Explore artículos, ensayos, reflexiones y aplicaciones prácticas del estoicismo en la vida cotidiana.",
  "home.discover.journal.cta": "Abrir The Stoic Journal",
  "home.cards.eyebrow": "StoicOs Cards",
  "home.cards.title": "El estoicismo, una idea a la vez.",
  "home.cards.body": "Explora las ideas estoicas a través de tarjetas visuales sobre el juicio, la virtud, el control, el carácter y la Libertad Interior.",
  "home.cards.cta": "Descubre las StoicOs Cards",
  "agora.next.title": "Quisiera profundizar en esto",
  "agora.next.p1": "¿Han despertado su interés las historias y enseñanzas de vida de Marco Aurelio, Epicteto, Séneca e Hiparquia?",
  "agora.next.p2": "Quizá reconozca esa sensación: esto me habla, y deseo explorarlo más a fondo.",
  "agora.next.p3": "Dentro de My StoicOs aprenderá, paso a paso, a aplicar las enseñanzas estoicas en la vida cotidiana. Se familiarizará con las tres disciplinas clásicas de la Stoa: Lógica, Física y Ética.",
  "agora.next.p4": "No solo para saber más sobre la filosofía, sino para aprender a pensar con mayor claridad, elegir con más conciencia y actuar con más firmeza cuando la vida le pone a prueba.",
  "nav.download": "Descargar",
  "nav.journal": "The Stoic Journal",
  "nav.stoicJournal": "The Stoic Journal",
  "nav.agoraMain": "Agora",
  "nav.aboutUs": "Sobre nosotros",
  "nav.mystoicos": "My StoicOs",
  "my.eyebrow": "My StoicOs",
  "my.welcome": "Bienvenido de nuevo",
  "my.traveler": "Viajero",
  "my.subtitle": "Su camino de estudio, práctica y reflexión.",
  "my.journalCta": "Continúe con su The Stoic Journal",
  "my.recFirst": "Primer paso recomendado",
  "my.startLogic": "Comience con Lógica",
  "my.logicSub": "Aprenda a ver con claridad antes de juzgar, elegir y actuar.",
  "my.beginLogic": "Comenzar Lógica",
  "my.module.library": "Living Library",
  "my.module.library.desc": "La sabiduría reunida de la Stoa — ensayos, términos y fuentes.",
  "my.settings.replayDesc": "Vea de nuevo la introducción cinematográfica a la Academy.",
  "my.aspirant": "Miembro aspirante",
  "my.memberSince": "Miembro desde",
  "my.introDay": "Introducción · Día {day} de 7",
  "my.todaysPractice": "Práctica de hoy",
  "my.morning": "Reflexión matutina",
  "my.practice": "Práctica diaria",
  "my.evening": "Reflexión vespertina",
  "my.freeLabel": "Escritura libre",
  "my.done": "Escrito",
  "my.open": "Abrir",
  "my.virtueFocus": "Virtud actual",
  "my.virtue.Wisdom": "Sabiduría",
  "my.virtue.Courage": "Coraje",
  "my.virtue.Justice": "Justicia",
  "my.virtue.Temperance": "Templanza",
  "my.streak": "Racha de reflexión",
  "my.streakDays": "{n} días",
  "my.streakDay": "1 día",
  "my.daysPracticed": "días de práctica",
  "my.inspiration": "Inspiración diaria",
  "my.recent": "Actividad reciente",
  "my.noActivity": "Su journal todavía está vacío. Comience con la reflexión de esta mañana.",
  "my.recommendations": "Siguiente recomendación",
  "my.rec.logic-lesson-1": "Comience el curso de Lógica",
  "my.rec.library-visit": "Visite la Living Library",
  "my.modules": "Su espacio de estudio",
  "my.module.journal": "My Journal",
  "my.module.journal.desc": "Reflexión de la mañana y de la noche, práctica diaria y escritura libre.",
  "my.module.academy": "My Academy",
  "my.module.academy.desc": "Progreso del curso, lecciones completadas, certificados y marcadores.",
  "my.module.journeys": "My Journeys",
  "my.module.journeys.desc": "Journeys actuales y completados con notas personales.",
  "my.module.virtues": "My Virtues",
  "my.module.virtues.desc": "Desarrollo en Sabiduría, Valentía, Justicia y Templanza.",
  "my.module.mentors": "Mentores",
  "my.module.mentors.desc": "Marco Aurelio, Epicteto, Séneca e Hiparquia.",
  "my.module.progress": "My Progress",
  "my.module.progress.desc": "Historial de reflexiones, estadísticas, rachas e hitos.",
  "my.module.settings": "Configuración",
  "my.module.settings.desc": "Perfil, idioma, notificaciones, privacidad y membresía.",
  "my.inPreparation": "En preparación",
  "my.logout": "Cerrar sesión",
  "join.eyebrow": "The Academy of Practical Wisdom",
  "join.title": "Únase al Journey",
  "join.loginTitle": "Continúe su Journey",
  "join.welcomeNote": "Después de su registro gratuito, obtiene acceso inmediato a las primeras lecciones de Lógica, Ética y Física dentro de My StoicOs.",
  "join.support": "Forje su carácter mediante la práctica diaria, la filosofía atemporal y la guía de los grandes mentores estoicos.",
  "join.name": "Su nombre",
  "join.email": "Correo electrónico",
  "join.password": "Contraseña (mín. 8 caracteres)",
  "join.registerCta": "Únase al Journey",
  "join.loginCta": "Continúe su Journey",
  "join.haveAccount": "Continúe su Journey",
  "join.newHere": "¿Es nuevo aquí? Únase al Journey",
  "trial.cta": "Comenzar mi introducción gratuita",
  "trial.hero.headline": "Comience su introducción gratuita",
  "trial.hero.subtitle": "Cree una cuenta gratuita de My StoicOs y obtenga acceso a las primeras lecciones de Lógica, Ética y Física. Descubra The Academy of Practical Wisdom y comience su journey.",
  "trial.hero.secondary": "Ya tengo una cuenta",
  "trial.locked.title": "Esta lección estará disponible cuando la membresía completa esté activa.",
  "trial.locked.body": "Tiene acceso a las lecciones introductorias de Lógica, Ética y Física. El plan de estudios completo estará disponible cuando se lance la membresía de The Academy of Practical Wisdom.",
  "trial.locked.back": "Volver a My StoicOs",
  "trial.locked.previewBody": "La vista previa completa del plan de estudios seguirá abierta para todos. Cree su cuenta gratuita para abrir las lecciones introductorias, llevar su Stoic Journal y seguir su progreso — o inicie sesión si ya es estudiante.",
  "trial.academy.note": "Las lecciones introductorias están pensadas como una primera aproximación a la Academy. El programa completo de estudio estará disponible cuando la membresía esté activa.",
  "ceremony.title": "Bienvenido a la Academy",
  "ceremony.body1": "Bienvenido, Aspirant Member.",
  "ceremony.body2": "Su membership ha sido registrada.",
  "ceremony.memberNumber": "Member Number",
  "ceremony.memberSince": "Member Since",
  "ceremony.firstStep": "Hoy da su primer paso hacia la Libertad Interior.",
  "ceremony.mentorsTitle": "Conozca a sus mentores",
  "ceremony.enter": "Entrar en My StoicOs",
  "ceremony.continueHint": "Toque para continuar",
  "onb.scene": "Escena {n} de {total}",
  "onb.next": "Siguiente",
  "onb.previous": "Anterior",
  "onb.skip": "Omitir",
  "onb.scene6Title": "La entrada de la Academy",
  "onb.scene6Note": "Esta escena está reservada. La entrada de la Academy se revelará aquí.",
  "onb.back": "Atrás",
  "onb.continue": "Continuar",
  "onb.ch1.title": "Bienvenido, viajero",
  "onb.ch1.desc": "Le dan la bienvenida al Gran Salón de la Academy of Practical Wisdom.",
  "onb.ch2.title": "Marcus Aurelius",
  "onb.ch2.desc": "Hipparchia presenta al filósofo-emperador — gobernó un imperio, pero antes se gobernó a sí mismo.",
  "onb.ch3.title": "Epictetus",
  "onb.ch3.desc": "Nacido esclavo, llegó a ser el más libre de los hombres. Su bastón conoce el largo camino de la perseverancia.",
  "onb.ch4.title": "Seneca",
  "onb.ch4.desc": "Estadista y escritor — convirtió las tormentas de la fortuna en cartas de sabiduría.",
  "onb.ch5.title": "Sus cuatro mentores",
  "onb.ch5.desc": "Cuatro voces, un solo camino. Sus mentores le esperan en el salón dorado.",
  "onb.ch6.title": "Su viaje comienza aquí",
  "onb.ch6.desc": "Entre en la Academy of Practical Wisdom y comience la práctica de llegar a ser quien es capaz de ser.",
  "onb.enter": "Entrar en la Academy",
  "onb.skipIntro": "Omitir introducción",
  "onb.begin": "Comenzar el viaje",
  "onb.sound.mute": "Silenciar narración",
  "onb.sound.unmute": "Activar narración",
  "onb.replay": "Reproducir de nuevo la narración",
  "onb.volume": "Volumen",
  "my.replayIntro": "Reproducir de nuevo la introducción",
  "journal.my.title": "My Journal",
  "journal.my.subtitle": "Una práctica filosófica diaria — la memoria viva de su desarrollo.",
  "journal.my.morningPrompt": "¿Qué me pedirá hoy el día? ¿Qué virtud practicaré deliberadamente?",
  "journal.my.practicePrompt": "¿Qué practiqué hoy? ¿Dónde actué de acuerdo con mis principios — y dónde no?",
  "journal.my.eveningPrompt": "¿Qué hice bien? ¿Qué podría haber hecho mejor? ¿Qué quedó sin hacer?",
  "journal.my.free": "Escritura libre",
  "journal.my.freeNew": "Nueva página",
  "journal.my.freeTitlePh": "Título (opcional)",
  "journal.my.writePh": "Escriba aquí…",
  "journal.my.saving": "Guardando…",
  "journal.my.saved": "Guardado",
  "journal.my.delete": "Eliminar",
  "journal.my.back": "Volver a My StoicOs",
  "journal.my.empty": "Aún no hay páginas libres.",
  "journal.my.freeLabel": "Entrada libre",
  "journal.my.freePrompt": "Escriba libremente — un pensamiento, una observación, una carta para usted mismo.",
  "my.journal.title": "My Journal",
  "my.journal.savedIn": "Guardado en My Journal",
  "my.journal.viewIn": "Abrir My Journal",
  "my.journal.newFree": "Nueva entrada libre",
  "my.journal.freeTitlePh": "Título (opcional)",
  "my.journal.searchPh": "Busque en su journal…",
  "my.journal.allDates": "Todas las fechas",
  "my.journal.filterAll": "Todo",
  "my.journal.entriesCount": "entradas",
  "my.journal.empty": "Aún no hay entradas. Escriba hoy su primera reflexión.",
  "my.journal.deleteConfirm": "¿Eliminar esta entrada?",
  "my.journal.deleteYes": "Eliminar",
  "my.journal.cancel": "Cancelar",
  "my.journal.back": "Volver",
  "my.journal.tabToday": "Hoy",
  "my.journal.tabArchive": "Archivo",
  "my.journal.tabMentor": "My Mentor Reviews",
  "my.mentor.title": "My Mentor Reviews",
  "my.mentor.empty": "Aún no ha recibido evaluaciones de mentor.",
  "my.mentor.info": "Las futuras respuestas del mentor aparecerán aquí y seguirán vinculadas a la entrada original en My Journal.",
  "my.journal.calendar": "Calendario",
  "my.journal.todayBtn": "Hoy",
  "join.forgotPassword": "¿Olvidó su contraseña?",
  "nav.cards": "Tarjetas de práctica",
  "nav.insights": "My Insights",
  "nav.books": "My Books",
  "nav.share": "Comparta sus pensamientos",
  "nav.agora": "Agora",
  "nav.watch": "Ver",
  "share.eyebrow": "Cartas a la Stoa",
  "share.title1": "Comparta",
  "share.title2": "Sus pensamientos",
  "share.headline": "Comparta Sus pensamientos",
  "share.lede": "Una continuación contemporánea de la correspondencia entre Séneca y su amigo Lucilio.",
  "share.dropCap": "Q",
  "share.p1": "Desde hace casi dos mil años, las cartas de Séneca a Lucilio han sido una de las invitaciones más serenas de la filosofía: un intercambio tranquilo, sin prisa, entre dos mentes en busca de la buena vida.",
  "share.p2": "StoicOs.ai está construido con ese mismo espíritu. Menos un producto para promocionar que una conversación en la que entrar.",
  "share.p3": "Si algo en estas páginas despierta una pregunta, una reflexión, un recuerdo o simplemente un pensamiento que le gustaría dejar por escrito, escriba. Leo cada carta personalmente.",
  "share.emailLabel": "Escriba al fundador",
  "share.reassurance": "Cada mensaje se lee personalmente. Aunque quizá no pueda responder de inmediato a todos los mensajes, sus pensamientos siempre son apreciados.",
  "share.signature.name": "Ed Korporaal",
  "share.signature.role": "Founder, StoicOs.ai",
  "share.form.title": "Escriba una Carta a la Stoa",
  "share.form.subtitle": "Una correspondencia moderna. Su mensaje llega directamente al fundador.",
  "share.form.nameLabel": "Nombre (opcional)",
  "share.form.namePlaceholder": "Lucilius",
  "share.form.emailLabel": "Correo electrónico (opcional)",
  "share.form.emailPlaceholder": "you@example.com",
  "share.form.messageLabel": "Sus pensamientos",
  "share.form.messagePlaceholder": "Escriba con libertad: una pregunta, una reflexión, una sugerencia…",
  "share.form.send": "Enviar mensaje",
  "share.form.sending": "Enviando…",
  "share.form.privacy": "Leído por una sola persona. Nunca se comparte.",
  "share.form.errEmpty": "Por favor, escriba un mensaje antes de enviarlo.",
  "share.form.errSend": "Algo interrumpió la entrega. Por favor, inténtelo de nuevo o escriba directamente a ek@stoicos.ai.",
  "share.form.successTitle": "Gracias. Su mensaje ha sido enviado a Ed a ek@stoicos.ai.",
  "share.form.successBody": "Cada carta se lee personalmente. La respuesta puede tardar un poco, pero llegará.",
  "share.form.savedTitle": "Su mensaje ha sido guardado.",
  "share.form.savedBody": "La entrega por correo electrónico no está disponible en este momento, así que todavía no he sido notificado por correo electrónico, pero su mensaje está guardado de forma segura y será leído. También puede escribir directamente a ek@stoicos.ai.",
  "share.form.deliveryNotice": "Los mensajes se envían directamente a:",
  "share.form.writeAgain": "Escriba otro mensaje",
  "footer.tagline": "StoicOs crea herramientas para la vida examinada. Virtue Guide es nuestro primer compañero: un diálogo guiado por IA con la sabiduría de Roma.",
  "footer.knowThyself": "Conócete a ti mismo",
  "footer.company": "Empresa",
  "footer.aboutLink": "Acerca de StoicOs",
  "footer.product": "Virtue Guide",
  "footer.ios": "Descargar para iOS",
  "footer.android": "Descargar para Android",
  "footer.rights": "Todos los derechos reservados.",
  "hero.eyebrow": "StoicOs.ai",
  "hero.title1": "Conózcase",
  "hero.title2": "a sí mismo",
  "hero.sub1": "Cultive la sabiduría.",
  "hero.sub2": "Fortalezca el carácter.",
  "hero.sub3": "Construya su ciudadela interior.",
  "hero.body": "Virtue Guide es un producto de StoicOs.ai. Una guía impulsada por IA para el autoconocimiento, el desarrollo del carácter y la sabiduría práctica, inspirada en los grandes pensadores estoicos.",
  "hero.bodyLead": "Virtue Guide es un producto de",
  "hero.bodyTail": "Una guía impulsada por IA para el autoconocimiento, el desarrollo del carácter y la sabiduría práctica, inspirada en Marco Aurelio, Séneca y Epicteto.",
  "hero.ctaPrimary": "Comience el viaje",
  "hero.ctaSecondary": "Entre en la Agora",
  "hero.alt": "Amanecer sobre el templo de Delfos con la inscripción ΓΝΩΘΙ ΣΕΑΥΤΟΝ, “Know Thyself”. Un viajero solitario recorre el camino de piedra hacia el templo. A la izquierda, un estandarte de Sabiduría (búho) sobre Justicia (balanza); a la derecha, estandartes de Valentía (león) sobre Templanza (cáliz). Bustos de piedra de Marco Aurelio, Séneca y Epicteto se elevan entre las nubes sobre el frontón mientras el sol asoma detrás de las montañas.",
  "hero.subtitle": "Un compañero de bolsillo para la vida examinada. Converse con Marco Aurelio, Séneca y Epicteto, y redescubra lo que significa vivir bien.",
  "hero.statusBeta": "Ahora en beta privada",
  "hero.statusRome": "Diseñado en Roma",
  "hero.scroll": "Desplácese",
  "coming.eyebrow": "Ya disponible",
  "coming.title1": "Virtue Guide",
  "coming.title2": "ya está disponible",
  "coming.subtitle": "Una nueva manera de explorar la filosofía estoica mediante la reflexión guiada por IA.",
  "coming.description": "Descubra cómo la sabiduría estoica atemporal se encuentra con la inteligencia artificial moderna. Virtue Guide está diseñado para ayudar a las personas a reflexionar, cuestionar sus juicios y fortalecer su carácter mediante conversaciones con los más grandes maestros estoicos de la historia.",
  "coming.video.trailer.eyebrow": "Tráiler oficial",
  "coming.video.trailer.title": "Virtue Guide: El tráiler oficial",
  "coming.video.trailer.caption": "Un primer vistazo al viaje.",
  "coming.cta.heading": "Sea de los primeros en experimentar Virtue Guide",
  "coming.cta.text": "Comience hoy su viaje estoico.\nDescargue Virtue Guide ahora — disponible en la Apple App Store y en Google Play.",
  "coming.available.note": "La película de arriba es nuestro tráiler de lanzamiento original — el lanzamiento que anuncia ya se ha producido.",
  "coming.available.line": "Virtue Guide ya está disponible en la Apple App Store y en Google Play.",
  "coming.comingSoon": "Próximamente",
  "coming.apple.line1": "En la App Store",
  "coming.apple.line2": "Descargar",
  "coming.google.line1": "En Google Play",
  "vgs.eyebrow": "Lanzamiento oficial — El compañero móvil",
  "vgs.title1": "Su viaje estoico,",
  "vgs.title2": "esté donde esté",
  "vgs.body": "My StoicOs es su cuenta personal y su entorno de aprendizaje en StoicOs.ai. Virtue Guide es su aplicación compañera para el móvil — reflexión diaria, orientación y conversaciones con los grandes maestros estoicos, allá donde le lleve la vida.",
  "vgs.sync": "Todo permanece sincronizado: su progreso, su diario y sus reflexiones viajan sin fisuras entre StoicOs.ai y Virtue Guide.",
  "vgs.trust": "Oficialmente disponible en la Apple App Store y en Google Play Store.",
  "fw.eyebrow": "Los Primeros Cien",
  "fw.title1": "Founders",
  "fw.title2": "Wall of Honor",
  "fw.subtitle": "Todo viaje significativo comienza con unas pocas personas que deciden creer antes de que el destino sea visible.",
  "fw.body1": "Los primeros 100 Founding Members de StoicOs.ai recibirán un lugar permanente en este Wall of Honor.",
  "fw.body2": "La membresía de Founding Member es completamente gratuita. El reconocimiento no se puede comprar.",
  "fw.body3": "Se gana sencillamente al convertirse en uno de los primeros 100 miembros registrados.",
  "fw.counterLabel": "Founding Members",
  "fw.remaining": "{n} plazas disponibles",
  "fw.empty": "Los primeros nombres se inscribirán aquí muy pronto.",
  "fw.cta.heading": "Conviértase en uno de los primeros 100 Founding Members",
  "fw.cta.b1": "Gratis para siempre",
  "fw.cta.b2": "Reconocimiento permanente",
  "fw.cta.b3": "Privacidad protegida",
  "fw.cta.b4": "Ayude a construir StoicOs.ai desde el principio",
  "fw.cta.button": "Crear mi cuenta gratuita de StoicOs",
  "join.fw.title": "Founders Wall of Honor",
  "join.fw.q": "Si usted se convierte en uno de los primeros 100 Founding Members, ¿podemos mostrarle en el Founders Wall of Honor público?",
  "join.fw.yes": "Sí — muestren mi nombre de pila y la inicial de mi apellido (por ejemplo: Daniel R.)",
  "join.fw.no": "No — no muestren mi nombre en el Founders Wall of Honor",
  "fwModal.eyebrow": "Founders Wall of Honor",
  "fwModal.title": "Bienvenido, Founding Member",
  "fwModal.body": "Usted es uno de los primeros 100 miembros de StoicOs.ai. Elija si aparece en el Founders Wall of Honor público — solo su nombre de pila y la inicial de su apellido pueden mostrarse.",
  "fwModal.save": "Guardar mi elección",
  "fwModal.later": "Decidir más tarde",
  "my.fw.title": "Privacidad — Founders Wall of Honor",
  "my.fw.badge": "Founding Member {number}",
  "my.fw.desc": "Elija si su nombre aparece en el Founders Wall of Honor público. Solo su nombre de pila y la inicial de su apellido pueden mostrarse. Su lugar en el Wall sigue el orden de registro.",
  "my.fw.saved": "Preferencia guardada.",
  "coming.watchLibrary": "Ver la biblioteca completa",
  "watch.eyebrow": "The Library",
  "watch.title": "Ver",
  "watch.lede": "Un archivo vivo de la voz de StoicOs.",
  "watch.intro": "Tráilers, voces de los maestros estoicos, tutoriales y serenas actualizaciones del producto. Se añaden nuevos videos a medida que el proyecto crece. No hay calendario, solo el trabajo.",
  "watch.browseLabel": "Explorar por",
  "watch.cat.all": "Todo",
  "watch.cat.trailer": "Tráiler oficial",
  "watch.cat.marcus": "Marco Aurelio",
  "watch.cat.seneca": "Séneca",
  "watch.cat.epictetus": "Epicteto",
  "watch.cat.cato": "Catón",
  "watch.cat.tutorials": "Tutoriales",
  "watch.cat.updates": "Actualizaciones del producto",
  "watch.empty.eyebrow": "Próximamente",
  "watch.empty.title": "Aquí todavía no hay nada.",
  "watch.empty.body": "Este estante de la biblioteca aún se está llenando. Vuelva pronto o explore otra categoría arriba.",
  "watch.video.trailer.eyebrow": "Tráiler oficial",
  "watch.video.trailer.title": "Virtue Guide: El tráiler oficial",
  "watch.video.trailer.caption": "Un primer vistazo al viaje. Un diálogo guiado por IA con la sabiduría de Roma, concebido para la vida examinada.",
  "mission.eyebrow": "Nuestra misión",
  "mission.headline1": "Estamos devolviendo la filosofía al lugar al que siempre ha pertenecido:",
  "mission.headline2": "las horas silenciosas de un día cualquiera.",
  "mission.body": "StoicOs crea sistemas operativos para la vida interior. Virtue Guide, nuestro primer acompañante, utiliza IA para ponerle en conversación con los grandes estoicos, de modo que la sabiduría ya no permanezca en un estante, sino que le acompañe, como una moneda en el bolsillo.",
  "philosophyMission.eyebrow": "Nuestra filosofía",
  "philosophyMission.headline.lead": "El mundo no necesita más información.",
  "philosophyMission.headline.accent": "Necesita más sabiduría.",
  "philosophyMission.body.para1": "En StoicOs.ai, nuestra misión es cultivar la sabiduría y hacerla comprensible, práctica y accesible para todos.",
  "philosophyMission.body.para2": "Creemos que la sabiduría no es un don reservado a unos pocos, sino una virtud que puede cultivarse mediante la reflexión, la razón y la práctica diaria.",
  "philosophyMission.body.para3": "Al unir la filosofía atemporal con una IA centrada en el ser humano, ayudamos a las personas a fortalecer su juicio, forjar su carácter y vivir con mayor propósito.",
  "philosophyMission.body.para4": "Porque un mundo mejor comienza con personas más sabias.",
  "philosophyMission.closing.line1": "Know Thyself.",
  "philosophyMission.closing.line2": "Cultive la sabiduría.",
  "philosophyMission.closing.line3": "Viva con virtud.",
  "philosophyMission.cta": "Comience su viaje",
  "academy.nav": "Academy",
  "academy.hero.eyebrow": "Academy",
  "academy.hero.title": "Academy de la sabiduría",
  "academy.hero.subtitle.lead": "La vida es el plan de estudios.",
  "academy.hero.subtitle.accent": "La virtud es la meta.",
  "academy.hero.cta": "Comience su viaje",
  "academy.hero.alt": "La entrada a la Academy de sabiduría práctica, StoicOs.ai",
  "academy.intro.title": "Introducción a la Academy",
  "academy.intro.sub1": "Antes de comenzar su viaje,",
  "academy.intro.sub2": "tómese dos minutos para conocer la visión que inspira la Academy.",
  "academy.intro.video.coming": "Próximamente: la introducción oficial de la Academy",
  "academy.intro.quote1": "Todo viaje comienza con un solo paso.",
  "academy.intro.quote2": "Toda vida comienza con una sola elección.",
  "nav.library": "Living Library",
  "library.hero.eyebrow": "El fundamento del conocimiento",
  "library.hero.title": "The Living Library",
  "library.hero.subtitle": "El repositorio en expansión de sabiduría práctica del mundo.",
  "library.hero.body1": "Preservar la sabiduría del pasado.",
  "library.hero.body2": "Conectarla con el presente.",
  "library.hero.body3": "Prepararla para el futuro.",
  "library.hero.cta": "Comenzar a explorar",
  "library.hero.backAcademy": "Volver a Academy",
  "library.hero.imageAlt": "The Living Library: un monumental edificio de mármol en el campus de Academy of Practical Wisdom",
  "library.hero.lead": "El fundamento central del conocimiento de Academy of Practical Wisdom.",
  "library.collections.title": "Las colecciones",
  "library.card.open": "Entrar",
  "library.growing": "The Living Library se cuida y se compone con esmero. Se añade nuevo conocimiento con el tiempo.",
  "library.category.emptyEyebrow": "En curación",
  "library.category.empty": "Esta sección está siendo curada actualmente como parte de The Living Library.",
  "library.category.back": "Volver a The Living Library",
  "library.search.title": "Buscar",
  "library.search.sub": "Encuentre cualquier cosa en The Living Library: filósofos, conceptos, virtudes, prácticas y más.",
  "library.search.placeholder": "Buscar en The Living Library…",
  "library.search.button": "Buscar",
  "library.search.hint": "Introduzca un término para buscar en The Living Library.",
  "library.search.empty": "Aún no se han publicado entradas coincidentes.",
  "library.search.empty2": "The Living Library sigue creciendo.",
  "library.search.explore": "Explorar las colecciones",
  "library.seo.description": "Descubra The Living Library de StoicOs.ai: un repositorio en expansión de sabiduría práctica, filosofía estoica, fuentes originales, investigación moderna y aprendizaje a lo largo de la vida.",
  "library.entry.relatedTitle": "Continúe su camino",
  "library.journey.label": "Journey",
  "library.journey.soon": "En curación. Este Journey se abrirá pronto.",
  "library.journey.return": "Volver a The Living Library",
  "library.journey.wisdom.name": "Sabiduría",
  "library.journey.wisdom.invite": "Comience donde comienza toda virtud: con un juicio claro.",
  "library.journey.courage.name": "Valentía",
  "library.journey.courage.invite": "Transforme el juicio sabio en acción valiente.",
  "library.journey.justice.name": "Justicia",
  "library.journey.justice.invite": "Descubra cómo la sabiduría se convierte en servicio a los demás.",
  "library.journey.temperance.name": "Templanza",
  "library.journey.temperance.invite": "Descubra cómo la sabiduría gobierna el yo.",
  "library.journey.wisdom.greek": "Phronēsis",
  "library.journey.courage.greek": "Andreia",
  "library.journey.justice.greek": "Dikaiosynē",
  "library.journey.temperance.greek": "Sōphrosynē",
  "library.virtues.heroTitle": "Las virtudes",
  "library.virtues.heroLine": "El carácter no se enseña solo con palabras, sino con la práctica.",
  "library.virtues.choose": "Elija una virtud para comenzar su camino",
  "library.rel.academy_lessons": "Lecciones de Academy",
  "library.rel.virtue_guide_conversations": "Conversaciones de Virtue Guide",
  "library.rel.journal_articles": "Artículos del Journal",
  "library.rel.videos": "Videos",
  "library.rel.original_sources": "Fuentes originales",
  "library.rel.modern_research": "Investigación moderna",
  "library.rel.related_concepts": "Conceptos relacionados",
  "library.rel.related_virtues": "Virtudes relacionadas",
  "library.rel.related_philosophers": "Filósofos relacionados",
  "library.rel.exercises": "Ejercicios",
  "library.rel.books": "Libros",
  "library.cats.philosophers.title": "Filósofos",
  "library.cats.philosophers.desc": "Las vidas, voces y enseñanzas de los maestros estoicos.",
  "library.cats.concepts.title": "Conceptos",
  "library.cats.concepts.desc": "Las ideas fundamentales que estructuran el pensamiento estoico.",
  "library.cats.virtues.title": "Virtudes",
  "library.cats.virtues.desc": "Sabiduría, justicia, valentía y templanza: los cuatro pilares.",
  "library.cats.practices.title": "Prácticas",
  "library.cats.practices.desc": "Ejercicios diarios que convierten la filosofía en una forma de vida.",
  "library.cats.sources.title": "Fuentes originales",
  "library.cats.sources.desc": "Los textos clásicos, en sus propias palabras.",
  "library.cats.history.title": "Historia",
  "library.cats.history.desc": "Desde el pórtico pintado de Atenas hasta nuestros días.",
  "library.cats.research.title": "Investigación moderna",
  "library.cats.research.desc": "Lo que la ciencia contemporánea dice sobre la práctica antigua.",
  "library.cats.leadership.title": "Liderazgo",
  "library.cats.leadership.desc": "Gobernarse a sí mismo primero, y luego a los demás.",
  "library.cats.relationships.title": "Relaciones",
  "library.cats.relationships.desc": "Vivir sabiamente con las personas que le han sido confiadas.",
  "library.cats.health.title": "Salud",
  "library.cats.health.desc": "El cuidado del cuerpo al servicio de la mente.",
  "library.cats.finance.title": "Finanzas",
  "library.cats.finance.desc": "Riqueza, suficiencia y el uso sabio de la fortuna.",
  "library.cats.society.title": "Sociedad",
  "library.cats.society.desc": "El ciudadano del mundo y el bien común.",
  "library.cats.glossary.title": "Glosario",
  "library.cats.glossary.desc": "Cada término del vocabulario estoico, definido.",
  "library.cats.search.title": "Buscar",
  "library.cats.search.desc": "Encuentre cualquier cosa en la Living Library.",
  "academy.why.eyebrow": "¿Por qué otra Academy?",
  "academy.why.p1": "La mayor parte de la educación enseña a las personas cómo ganarse la vida.",
  "academy.why.p2": "Muy poco enseña a las personas cómo vivir.",
  "academy.why.p3": "El conocimiento está en todas partes.",
  "academy.why.p4.lead": "La sabiduría es",
  "academy.why.p4.accent": "rara.",
  "academy.why.p5": "La Academy existe para cambiar eso.",
  "academy.how.eyebrow": "Cómo funciona",
  "academy.how.title": "Un viaje, seis movimientos que se despliegan.",
  "academy.how.body": "La Academy no enseña materias. Enseña un ritmo: el movimiento por el cual un momento vivido se convierte en virtud, y la virtud se convierte en carácter.",
  "academy.how.step.experience": "Experiencia",
  "academy.how.step.reflection": "Reflexión",
  "academy.how.step.understanding": "Comprensión",
  "academy.how.step.virtue": "Virtud",
  "academy.how.step.character": "Carácter",
  "academy.how.step.wisdom": "Sabiduría",
  "academy.map.title": "El mapa de la sabiduría práctica",
  "academy.map.p1": "Todo viaje comienza con la comprensión del conjunto.",
  "academy.map.p2": "El mapa de la sabiduría práctica ofrece una visión general visual de la tradición estoica tal como se enseña en la Academy of Practical Wisdom.",
  "academy.map.p3": "Cada concepto está arraigado en las fuentes clásicas estoicas conservadas. La organización visual es una síntesis educativa original de StoicOs.ai, creada para hacer que el estoicismo sea comprensible, práctico y accesible.",
  "academy.map.alt": "El mapa de la sabiduría práctica: una visión general visual de la tradición estoica tal como se enseña en la Academy of Practical Wisdom",
  "academy.map.note.label": "Nota histórica",
  "academy.map.note.text": "Cada concepto de este mapa pretende poder rastrearse hasta las fuentes clásicas estoicas conservadas. La organización visual es un modelo educativo original creado por StoicOs.ai.",
  "academy.disc.eyebrow": "Las tres disciplinas del estoicismo",
  "academy.disc.title": "Una filosofía. Tres disciplinas inseparables.",
  "academy.disc.body": "Los estoicos antiguos nunca enseñaron la ética de forma aislada. Su filosofía era un único todo vivo de tres disciplinas, comparado por los antiguos maestros con un jardín: la Lógica, el muro que protege; la Física, la tierra que nutre; la Ética, el fruto para el que existe el jardín. El viajero que entra en esta Academy descubre el estoicismo exactamente como lo habría descubierto un estudiante al entrar en la antigua Stoa.",
  "academy.disc.concept.logic": "La Lógica enseña a pensar.",
  "academy.disc.concept.physics": "La Física enseña qué es la realidad.",
  "academy.disc.concept.ethics": "La Ética enseña cómo vivir.",
  "academy.disc.concept.close": "Solo juntas forman el estoicismo.",
  "academy.disc.topicsLabel": "Futuros Learning Journeys",
  "academy.disc.mystoicos.title": "Siga estas lecciones en My StoicOs",
  "academy.disc.mystoicos.text": "Cree gratis su My StoicOs y obtenga acceso a las primeras lecciones de Lógica, Física y Ética, a su progreso personal y a sus reflexiones guardadas.",
  "academy.disc.start.logic": "Comenzar Lógica en My StoicOs",
  "academy.disc.start.physics": "Comenzar Física en My StoicOs",
  "academy.disc.start.ethics": "Comenzar Ética en My StoicOs",
  "academy.disc.freeAccount": "Se requiere una cuenta gratuita",
  "academy.disc.logic.title": "Lógica estoica",
  "academy.disc.logic.subtitle": "Cómo llegamos a la verdad",
  "academy.disc.logic.classical": "Logikē",
  "academy.disc.logic.body": "Antes de que un estoico se pregunte cómo vivir, se pregunta cómo conocer. La Lógica estoica es la disciplina del pensar mismo: cómo llega una impresión, cómo el juicio la examina y cuándo una mente puede decir con razón “verdadero”. Enseña cómo debe pensar un ser humano antes de actuar.",
  "academy.disc.logic.topics": "Impresiones (Phantasiai)|Asentimiento (Synkatathesis)|Juicio|Razón|Conocimiento|Verdad|Sabiduría frente a opinión|La disciplina del pensar",
  "academy.disc.status.open": "Ya abierto",
  "academy.nav.switcherLabel": "Cambiar de disciplina",
  "academy.nav.lessonNavLabel": "Navegación de lecciones",
  "academy.nav.goTo.logic": "Ir a Lógica",
  "academy.nav.goTo.physics": "Ir a Física",
  "academy.nav.goTo.ethics": "Ir a Ética",
  "academy.nav.name.logic": "Lógica",
  "academy.nav.name.physics": "Física",
  "academy.nav.name.ethics": "Ética",
  "academy.nav.active": "Activo",
  "academy.nav.comingSoon": "Próximamente",
  "academy.nav.prevLesson": "Lección anterior",
  "academy.nav.nextLesson": "Lección siguiente",
  "academy.nav.lessonN": "Lección {n}",
  "academy.nav.position": "Fase {phase} · Lección {lesson} de {total}",
  "academy.nav.backToLesson": "Volver a la lección",
  "academy.nav.backToPhase": "Volver al resumen de la fase",
  "academy.lesson.virtueSeal": "Ponga a prueba su juicio con las cuatro virtudes.",
  "academy.nav.backToCourse": "Volver al resumen del curso",
  "academy.nav.resume": "Continuar donde lo dejó",
  "academy.nav.openCourseFirst": "Abrir curso",
  "academy.nav.reflectionSaved": "Reflexión guardada",
  "academy.nav.lessonCompleted": "Lección completada",
  "academy.nav.status.notStarted": "Sin empezar",
  "academy.nav.status.inProgress": "En curso",
  "academy.nav.status.completed": "Completado",
  "academy.nav.lessonsCompleted": "{x} de {y} lecciones completadas",
  "academy.nav.openCourse": "Abrir curso",
  "academy.nav.openPhase": "Abrir fase",
  "academy.nav.openLesson": "Abrir lección",
  "academy.nav.completePhase": "Completar la fase {n}",
  "academy.nav.continueChamber": "Continuar hacia la Chamber",
  "academy.nav.continueToLesson": "Continuar con la lección {n}",
  "academy.nav.viewProgress": "Ver mi progreso",
  "academy.nav.viewPhase": "Ver resumen de la fase",
  "academy.nav.viewPath": "Ver mi camino de desarrollo",
  "academy.nav.unsavedWarning": "Tiene texto no guardado. ¿Desea salir de todos modos? Se ha conservado un borrador cuando ha sido posible.",
  "academy.nav.myWork": "Ver My Work",
  "academy.mywork.title": "My Work",
  "academy.mywork.subtitle": "Borradores, reflexiones y ejercicios completados",
  "academy.mywork.empty": "Aún no hay nada guardado. Sus borradores, reflexiones y ejercicios completados se reunirán aquí.",
  "academy.mywork.sort": "Primero lo guardado más recientemente",
  "academy.mywork.filter.discipline": "Disciplina",
  "academy.mywork.filter.status": "Estado",
  "academy.mywork.filter.type": "Tipo",
  "academy.mywork.filter.all": "Todo",
  "academy.mywork.status.draft": "Borrador",
  "academy.mywork.status.inProgress": "En curso",
  "academy.mywork.status.completed": "Completado",
  "academy.mywork.status.archived": "Archivado",
  "academy.mywork.type.lesson": "Trabajo de la lección",
  "academy.mywork.type.record": "Registro",
  "academy.mywork.type.practice": "Registro de práctica",
  "academy.mywork.type.evidence": "Demostración",
  "academy.mywork.type.chamber": "Chamber",
  "academy.mywork.action.continue": "Seguir editando",
  "academy.mywork.action.view": "Ver",
  "academy.mywork.action.gotoLesson": "Ir a la lección relacionada",
  "academy.mywork.action.delete": "Eliminar",
  "academy.mywork.deleteConfirm": "¿Desea eliminar este trabajo guardado? Esta acción no se puede deshacer.",
  "academy.mywork.writtenIn.nl": "Escrito en neerlandés",
  "academy.mywork.writtenIn.en": "Escrito en inglés",
  "academy.mywork.createdAt": "Creado",
  "academy.mywork.savedAt": "Último guardado",
  "academy.mywork.completedAt": "Completado el",
  "academy.mywork.lesson": "Lección",
  "academy.mywork.phase": "Fase",
  "academy.mywork.storageNote": "Su trabajo se almacena en el servidor, vinculado a un ID anónimo guardado en este navegador. Aún no está vinculado a una cuenta: no le acompaña a otros dispositivos, y borrar los datos del navegador rompe el vínculo.",
  "academy.save.saving": "Guardando cambios…",
  "academy.save.saved": "✓ Guardado en tu cuenta StoicOs",
  "academy.save.failed": "Error al guardar — inténtelo de nuevo",
  "academy.save.lastSaved": "Último guardado el {date} a las {time}",
  "academy.save.draftBtn": "Guardar borrador",
  "academy.save.completeBtn": "Guardar y completar la lección",
  "academy.save.completedNote": "Lección completada",
  "academy.save.keepWriting": "Seguir escribiendo",
  "academy.save.backToLesson": "Volver a la lección",
  "academy.disc.status.preparation": "En preparación",
  "academy.disc.logic.cta": "Entre en el Salón del Juicio Claro",
  "academy.disc.physics.title": "Física estoica",
  "academy.disc.physics.subtitle": "Comprender la realidad",
  "academy.disc.physics.classical": "Physikē",
  "academy.disc.physics.body": "No es física en el sentido moderno, sino la comprensión de la Naturaleza, la Realidad y el Cosmos: el todo ordenado del que formamos parte. Los estoicos sostenían que la ética solo puede comprenderse verdaderamente después de comprender la realidad misma. Una de las alas más profundas de la Academy.",
  "academy.disc.physics.topics": "El Cosmos|Logos|Physis|Pneuma|Sympatheia|Providencia|Destino (Heimarmenē)|Causalidad|El alma humana|Hegemonikon|Ekpyrosis|Vivir de acuerdo con la Naturaleza",
  "academy.disc.ethics.title": "Ética estoica",
  "academy.disc.ethics.subtitle": "El arte de vivir",
  "academy.disc.ethics.classical": "Ēthikē",
  "academy.disc.ethics.body": "La Ética es donde la Lógica y la Física se convierten en vida: la aplicación práctica del pensamiento claro y de la realidad comprendida. Aquí la Academy cultiva las cuatro virtudes cardinales, las pasiones y sus contrapartes saludables, y la formación diaria del carácter en el camino hacia la eudaimonia.",
  "academy.disc.ethics.topics": "Las cuatro virtudes cardinales|Acciones apropiadas (Kathēkonta)|Pasiones (Pathē)|Emociones saludables (Eupatheiai)|Formación del carácter|Práctica diaria|El prokopton|Eudaimonia",
  "academy.curriculum.eyebrow": "El primer currículo",
  "academy.curriculum.title": "Trece puertas hacia una vida entera de práctica.",
  "academy.curriculum.body": "Cada tarjeta abre un camino completo de lecturas, reflexiones, diálogos con Virtue Guide y ejercicios diarios. Avance a su propio ritmo. El currículo espera.",
  "academy.card.welcome": "Bienvenido, estudiante",
  "academy.card.welcomeClassical": "Prooimion",
  "academy.card.welcomeSub": "Entre en The Stoa. Conozca a su mentor.",
  "academy.card.lifeCurriculum": "La vida es el currículo",
  "academy.card.lifeCurriculumClassical": "Askēsis",
  "academy.card.lifeCurriculumSub": "Convierta cada día ordinario en una lección de virtud.",
  "academy.card.knowThyself": "Know Thyself",
  "academy.card.knowThyselfClassical": "Gnōthi Seauton",
  "academy.card.knowThyselfSub": "Descubra quién es antes de decidir en quién quiere convertirse.",
  "academy.card.fourVirtues": "Las cuatro virtudes",
  "academy.card.fourVirtuesClassical": "Aretē",
  "academy.card.fourVirtuesSub": "Forje el carácter que guía cada decisión.",
  "academy.card.emotions": "Emociones",
  "academy.card.emotionsClassical": "Pathē",
  "academy.card.emotionsSub": "Aprenda a sentir profundamente sin perder su centro.",
  "academy.card.judgement": "Juicio",
  "academy.card.judgementClassical": "Prohairesis",
  "academy.card.judgementSub": "Aprenda a ver la realidad con claridad antes de elegir.",
  "academy.card.selfMastery": "Dominio de sí",
  "academy.card.selfMasteryClassical": "Enkrateia",
  "academy.card.selfMasterySub": "Domine la voluntad que gobierna toda otra elección.",
  "academy.card.fortuna": "Fortuna",
  "academy.card.fortunaClassical": "Fortuna",
  "academy.card.fortunaSub": "Domine la riqueza, el éxito y la pérdida sin convertirse en su siervo.",
  "academy.card.relationships": "Relaciones",
  "academy.card.relationshipsClassical": "Philia",
  "academy.card.relationshipsSub": "Cultive vínculos significativos mediante la sabiduría, la confianza y la virtud.",
  "academy.card.purpose": "Propósito",
  "academy.card.purposeClassical": "Telos",
  "academy.card.purposeSub": "Descubra una vida guiada por el sentido en lugar de la distracción.",
  "academy.card.death": "Muerte",
  "academy.card.deathClassical": "Memento Mori",
  "academy.card.deathSub": "Deje que la mortalidad le enseñe a vivir plenamente.",
  "academy.card.resilience": "Resiliencia",
  "academy.card.resilienceClassical": "Amor Fati",
  "academy.card.resilienceSub": "Transforme la adversidad en fortaleza y carácter.",
  "academy.card.leadership": "Liderazgo",
  "academy.card.leadershipClassical": "Hēgemonikon",
  "academy.card.leadershipSub": "Guíese primero a sí mismo, luego sirva a los demás con integridad.",
  "academy.card.openPath": "Entre en el camino",
  "academy.mentor.eyebrow": "Conozca a su mentor",
  "academy.mentor.title.lead": "Su mentor",
  "academy.mentor.title.accent": "nunca duerme.",
  "academy.mentor.body1": "Virtue Guide no es un chatbot. Es su mentor personal dentro de la Academy: siempre consciente del plan de estudios, siempre atento a su progreso, siempre dispuesto.",
  "academy.mentor.body2": "Pregunte. Reflexione. Practique. Crezca.",
  "academy.mentor.body3": "Virtue Guide le acompaña en cada lección.",
  "academy.mentor.always1": "24 horas al día.",
  "academy.mentor.always2": "365 días al año.",
  "academy.mentor.cta": "Hable con Virtue Guide",
  "academy.future.eyebrow": "La Academy del futuro",
  "academy.future.title": "Esto es solo el comienzo.",
  "academy.future.body": "El Primer Currículo es un camino. Con el tiempo, la Academy abrirá nuevos caminos para toda la vida, cada uno un ámbito que una vida humana nunca puede agotar.",
  "academy.future.wisdom": "Sabiduría",
  "academy.future.justice": "Justicia",
  "academy.future.courage": "Valentía",
  "academy.future.temperance": "Templanza",
  "academy.future.purpose": "Propósito",
  "academy.future.love": "Amor",
  "academy.future.leadership": "Liderazgo",
  "academy.future.finance": "Finanzas",
  "academy.future.parenthood": "Paternidad",
  "academy.future.health": "Salud",
  "academy.future.legacy": "Legado",
  "academy.future.death": "Muerte",
  "academy.future.meaning": "Sentido",
  "academy.future.modernLife": "Vida moderna",
  "academy.future.footer": "Cada materia se convierte en un camino de aprendizaje para toda la vida.",
  "academy.closing.line1": "Usted no se aparta de la vida para estudiar filosofía.",
  "academy.closing.line2": "Usted estudia filosofía a través de la vida misma.",
  "academy.closing.cta": "Comience su camino",
  "homeAcademy.primary.eyebrow": "La Academy de la sabiduría",
  "homeAcademy.primary.headline": "La vida es el currículo.",
  "homeAcademy.primary.accent": "La virtud es la meta.",
  "homeAcademy.primary.body": "Una escuela viva para la vida examinada. Trece puertas, una vida entera de práctica, guiada por Marco Aurelio, Séneca y Epicteto, y por un mentor que nunca duerme.",
  "homeAcademy.primary.cta": "Entrar en la Academy",
  "homeAcademy.secondary.eyebrow": "Comience la práctica",
  "homeAcademy.secondary.headline": "Usted no se aparta de la vida para estudiar filosofía.",
  "homeAcademy.secondary.accent": "La estudia a través de la vida misma.",
  "homeAcademy.secondary.body": "La Academy es donde la reflexión se convierte en disciplina, y la disciplina en carácter. Avance a su propio ritmo. El currículo espera.",
  "homeAcademy.secondary.cta": "Abrir la Academy",
  "guides.eyebrow": "Guías destacadas",
  "guides.headline1": "Tres voces.",
  "guides.headline2": "Dos mil años.",
  "guides.intro": "Cada guía aporta su propio temperamento: el emperador, el senador, el esclavo. Todos escribieron sobre las mismas preguntas que usted lleva consigo hoy.",
  "guides.marcusRole": "El emperador filósofo",
  "guides.marcusMeta": "Emperador romano · 121–180 d. C.",
  "guides.marcusDesc": "Autor de Meditaciones. Habla con una serena gravedad imperial, reflexiva y vuelta hacia el interior.",
  "guides.senecaRole": "El estadista y autor de cartas",
  "guides.senecaMeta": "Estadista romano · c. 4 a. C. – 65 d. C.",
  "guides.senecaDesc": "Autor de Cartas de un estoico. Elocuente, cálido, como un sabio amigo mayor.",
  "guides.epictetusRole": "El esclavo liberado",
  "guides.epictetusMeta": "Filósofo estoico · c. 50–135 d. C.",
  "guides.epictetusDesc": "Autor de los Discursos y el Enquiridión. Habla con sencillez y franqueza, con un fuego disciplinado.",
  "guides.guidePrefix": "Guía",
  "features.eyebrow": "La aplicación",
  "features.headline1": "No es otra aplicación de bienestar.",
  "features.headline2": "Es una disciplina.",
  "features.dialogue.title": "Diálogo guiado por IA",
  "features.dialogue.copy": "Converse con voces modeladas por las meditaciones de Aurelio, las cartas de Séneca y los Discursos de Epicteto.",
  "features.reflection.title": "Reflexión diaria",
  "features.reflection.copy": "Una sola virtud para considerar cada mañana. Una sola pregunta con la que sentarse cada noche.",
  "features.journal.title": "Diario privado",
  "features.journal.copy": "Un cuaderno cifrado de extremo a extremo para su vida examinada. Solo suyo.",
  "features.goldenHour.title": "El modo de la hora dorada",
  "features.goldenHour.copy": "Sesiones pausadas y cálidas, diseñadas para los momentos más contemplativos del día.",
  "features.compass.title": "Brújula de las virtudes",
  "features.compass.copy": "Siga la sabiduría, el coraje, la justicia y la templanza, las virtudes cardinales, como una práctica serena.",
  "features.premium.title": "Guía estoica",
  "features.premium.copy": "Modelos afinados con textos estoicos fundamentales. Sin lugares comunes ni trucos de productividad. Solo filosofía.",
  "preview.eyebrow": "Un compañero sereno",
  "preview.headline1": "Diseñado para la",
  "preview.headline2": "hora dorada.",
  "preview.body": "Virtue Guide está concebido para usarse con calma. Cinco minutos al amanecer. Diez minutos antes de dormir. Justo el tiempo suficiente para escucharse pensar.",
  "preview.stat1": "Virtudes cardinales",
  "preview.stat2": "Conversaciones",
  "preview.stat3": "Reflexiones diarias",
  "preview.stat4": "Notificaciones, nunca",
  "cta.eyebrow": "Comience",
  "cta.headline1": "La vida no examinada",
  "cta.headline2": "no merece ser vivida.",
  "cta.body": "Descargue Virtue Guide. Converse con los estoicos. Comience la práctica hoy.",
  "cta.available": "Oficialmente disponible en la Apple App Store y en Google Play Store.",
  "buildingInPublic.eyebrow": "Un proyecto vivo",
  "buildingInPublic.title": "Construir en público",
  "buildingInPublic.intro": "Está viendo cómo se construyen StoicOs.ai y Virtue Guide, tal como en otro tiempo se construyó Roma.",
  "buildingInPublic.line1": "Piedra a piedra.",
  "buildingInPublic.line2": "Lección a lección.",
  "buildingInPublic.line3": "Virtud por virtud.",
  "buildingInPublic.body1": "Así como Roma no se construyó en un día, tampoco la sabiduría, el carácter ni las herramientas que nos ayudan a cultivarlos se forman en un solo día.",
  "buildingInPublic.body2": "StoicOs.ai y Virtue Guide evolucionan continuamente. Cada actualización, cada lección, cada reflexión y cada función es una piedra más colocada con esmero.",
  "buildingInPublic.outro": "Esperamos que disfrute del viaje tanto como nosotros.",
  "buildingInPublic.thanks": "Gracias por construir el futuro con nosotros.",
  "rotateHint.title": "Gire su dispositivo.",
  "rotateHint.body": "Descubra la Stoa cinematográfica completa en formato 16:3.",
  "founder.eyebrow": "Historia del fundador",
  "founder.headline1": "Por qué",
  "founder.headline2": "existe.",
  "founder.role": "Fundador, StoicOs",
  "founder.tagline": "Creador de Virtue Guide",
  "founder.quote1": "“La aplicación no es la meta. La aplicación es la herramienta.”",
  "founder.toggleOpen": "Leer la historia del fundador",
  "founder.toggleClose": "Ocultar la historia del fundador",
  "founder.letter": "Una carta personal del fundador",
  "founder.p1": "Mi motivación es en realidad bastante sencilla.",
  "founder.p2": "A lo largo de los años he estudiado el estoicismo, el autoconocimiento y la sabiduría práctica. Estas ideas me ayudaron a atravesar períodos difíciles en mi propia vida, y creo que también pueden ayudar a otras personas.",
  "founder.p3": "Virtue Guide fue creado para hacer esa sabiduría más accesible.",
  "founder.p4": "No todo el mundo tiene el tiempo, la energía o el deseo de leer libros de filosofía. Sin embargo, muchas personas buscan orientación, reflexión y un poco más de claridad en su vida diaria.",
  "founder.p5a": "La aplicación no es el objetivo.",
  "founder.p5b": "La aplicación es la herramienta.",
  "founder.p6": "El objetivo es ayudar a las personas a ser un poco más sabias, un poco más serenas y un poco más conscientes de cómo viven.",
  "founder.p8": "El beneficio no es el propósito.",
  "founder.p9": "El propósito es poner la sabiduría práctica a disposición de las personas cuando la necesiten.",
  "founder.quote2": "El conocimiento solo se convierte en sabiduría cuando se vive.",
  "founder.p10": "Por eso, Virtue Guide no trata de coleccionar citas ni de memorizar filosofía.",
  "founder.p11": "Se trata de llevar la sabiduría a la vida diaria.",
  "founder.cadence1": "Una reflexión.",
  "founder.cadence2": "Una conversación.",
  "founder.cadence3": "Una decisión.",
  "founder.cadence4": "Un día a la vez.",
  "founder.p12": "Los estoicos enseñaban que la filosofía no es algo para admirar.",
  "founder.p13": "Es algo para practicar.",
  "founder.p14": "Hasta que un día seamos devueltos a la Naturaleza y al Logos del que procedemos.",
  "founder.closingMain": "Know Thyself.",
  "founder.closingSub": "Comprender es libertad.",
  "freeQuote.ctaOverline": "Gratis para usted",
  "freeQuote.ctaLabel": "Su reflexión estoica",
  "freeQuote.modalEyebrow": "Su reflexión estoica",
  "freeQuote.modalHeadline1": "De las citas",
  "freeQuote.modalHeadline2": "a la práctica.",
  "freeQuote.reflection": "Reflexión",
  "freeQuote.practice": "Práctica de hoy",
  "freeQuote.another": "Otra reflexión",
  "freeQuote.comingSoon": "Virtue Guide ya está disponible.",
  "freeQuote.comingSoonBody": "Un acompañante de bolsillo para la reflexión diaria, guiado por Marco Aurelio, Séneca y Epicteto.",
  "freeQuote.emailPlaceholder": "usted@ejemplo.com",
  "freeQuote.notify": "Avísenme",
  "freeQuote.sending": "Enviando…",
  "freeQuote.successOverline": "Está en la lista",
  "freeQuote.successThanks": "Gracias.",
  "freeQuote.successBody": "Hasta que llegue Virtue Guide: know thyself, y viva bien hoy.",
  "freeQuote.footerTag": "El conocimiento solo se convierte en sabiduría cuando se vive.",
  "notify.overline": "Próximamente",
  "notify.headline1": "Algo nuevo está",
  "notify.headline2": "en camino.",
  "notify.body": "Esta parte de StoicOs.ai se está preparando con esmero. Deje su correo electrónico y le avisaremos en cuanto abra.",
  "notify.storeApple": "Apple App Store",
  "notify.storeGoogle": "Google Play Store",
  "notify.storeBoth": "App Store y Google Play Store",
  "notify.emailLabel": "Correo electrónico",
  "notify.button": "Avíseme",
  "notify.sending": "Enviando…",
  "notify.noSpam": "Sin spam. Un correo electrónico, cuando la aplicación esté lista.",
  "notify.successOverline": "Está en la lista",
  "notify.thanks": "Gracias.",
  "notify.successBody": "Le escribiremos en cuanto abra. Hasta entonces:",
  "notify.knowThyself": "know thyself.",
  "notify.close": "Cerrar",
  "notify.errInvalid": "Introduzca un correo electrónico válido.",
  "notify.errGeneric": "Algo salió mal. Inténtelo de nuevo o escriba a ek@stoicos.ai.",
  "store.appstoreLine1": "Descárguela en",
  "store.appstoreLine2": "App Store",
  "store.playLine1": "Consígala en",
  "store.playLine2": "Google Play",
  "about.eyebrow": "Acerca de StoicOs",
  "about.headline1": "Un sistema operativo",
  "about.headline2": "para la vida interior.",
  "about.p1": "StoicOs es un pequeño estudio que crea software para la vida examinada. Creemos que la tecnología más importante de la próxima década no serán las herramientas de productividad. Serán las herramientas que usemos para vivir con más sabiduría.",
  "about.p2_pre": "Nuestro primer producto, ",
  "about.p2_em": "Virtue Guide",
  "about.p2_post": ", es una aplicación de acompañamiento arraigada en la filosofía estoica. No le optimiza. No le convierte en un juego. Le invita a detenerse un momento ante una sola pregunta y a considerar cómo la habría respondido un emperador, un senador o un esclavo liberado que vivió hace dos mil años.",
  "about.p3": "Trabajamos entre Roma y el internet abierto. Nos inspiramos en el mármol y la hora dorada, en la disciplina de la columnata y la calma del ciprés al atardecer. Construimos despacio. Publicamos pocas veces. Esperamos que se note.",
  "about.statFounded": "Fundado",
  "about.statBased": "Sede",
  "about.statApp": "Primera aplicación",
  "about.basedValue": "Roma / Web",
  "about.contactLink": "Hable con nosotros",
  "about.nav.aria": "Sobre StoicOs.ai",
  "about.nav.why": "Por qué StoicOs.ai",
  "about.nav.founders": "Discurso del fundador",
  "about.nav.stoa": "La Digital Stoa",
  "about.nav.disciplines": "Lógica · Física · Ética",
  "about.nav.lifelong": "Nunca es tarde para aprender",
  "about.stoa.title": "La Digital Stoa",
  "about.stoa.body": "StoicOs.ai está construido como una Stoa digital: un lugar tranquilo donde los maestros clásicos — Marco Aurelio, Epicteto, Séneca e Hipparchia — le guían en la práctica de la sabiduría práctica. No es una fábrica de cursos, sino una escuela en el sentido original: un lugar para practicar, examinar y crecer, a su propio ritmo.",
  "about.disc.title": "Lógica, Física y Ética",
  "about.disc.logic.title": "Lógica",
  "about.disc.logic.body": "Aprender a percibir y juzgar con claridad. Usted examina sus impresiones, reconoce las conclusiones precipitadas y aprende cuándo asentir — o no — a una primera impresión.",
  "about.disc.physics.title": "Física",
  "about.disc.physics.body": "Aceptar la realidad tal como es. Usted aprende a distinguir lo que está bajo su control y lo que no, y encuentra la paz en el orden de la naturaleza.",
  "about.disc.ethics.title": "Ética",
  "about.disc.ethics.body": "Convertir la sabiduría en acción. Usted practica las cuatro virtudes — sabiduría, valentía, justicia y templanza — en las decisiones de cada día.",
  "about.lifelong.title": "Nunca se es demasiado mayor para aprender.",
  "about.lifelong.body": "La sabiduría no conoce edad. Ya esté usted al comienzo de su vida adulta, en medio de su carrera o mirando atrás a muchos años de experiencia: mientras esté dispuesto a examinarse con honestidad, podrá seguir aprendiendo. No para convertirse en otra persona. Sino para ser más consciente de quién es, de cómo juzga y de quién elige ser a partir de hoy.",
  "about.lifelong.quote": "No pierdas más tiempo discutiendo cómo debe ser un hombre bueno. Sé uno de ellos.",
  "about.lifelong.cite": "— Marco Aurelio, Meditaciones 10.16",
  "about.lifelong.p1": "La Stoa no es solo algo sobre lo que leer. Pide ser practicada.",
  "about.lifelong.line1": "No solo hablar de sabiduría, sino elegir con más sabiduría.",
  "about.lifelong.line2": "No solo hablar de valentía, sino actuar con valentía.",
  "about.lifelong.line3": "No solo admirar la justicia, sino vivir con justicia.",
  "about.lifelong.line4": "No solo comprender la templanza, sino practicarla a diario.",
  "about.lifelong.p3": "Su práctica comienza con la próxima decisión que tome.",
  "about.closing": "La libertad interior es el destino.",
  "join.innerFreedom": "La libertad interior es el destino",
  "privacy.eyebrow": "Legal",
  "privacy.headline1": "Política de",
  "privacy.headline2": "privacidad.",
  "privacy.effective": "Entrada en vigor: enero de 2026",
  "privacy.s1.title": "1. Nuestro compromiso",
  "privacy.s1.body": "StoicOs crea software para la vida interior. Tratamos sus datos con la misma discreción que esperaríamos para los nuestros. Recopilamos el mínimo necesario para que Virtue Guide funcione, y no vendemos ni alquilamos información personal a nadie. Nunca.",
  "privacy.s2.title": "2. Información que recopilamos",
  "privacy.s2.body": "Información de la cuenta (correo electrónico y nombre opcional) cuando crea una cuenta. Información de uso (sesiones y funciones utilizadas) para mejorar la aplicación. Contenido de las conversaciones que usted elige guardar en su diario privado, cifrado en reposo y accesible solo para usted. No recopilamos contactos, ubicación ni identificadores del dispositivo más allá de lo estrictamente necesario.",
  "privacy.s3.title": "3. Cómo usamos la información",
  "privacy.s3.body": "Para ofrecer y mantener Virtue Guide; para responder a sus solicitudes de soporte; para detectar y prevenir abusos; y para mejorar la aplicación con el tiempo de forma agregada y anonimizada. No usamos sus entradas del diario para entrenar modelos de IA.",
  "privacy.s4.title": "4. Conversaciones con IA",
  "privacy.s4.body": "Las conversaciones con la Guía se canalizan a través de proveedores de modelos lingüísticos de gran escala bajo estrictos acuerdos de tratamiento de datos. No conservamos transcripciones de las conversaciones en nuestros servidores, a menos que usted las guarde explícitamente. El contenido guardado se cifra en el dispositivo y se sincroniza mediante canales cifrados de extremo a extremo.",
  "privacy.s5.title": "5. Intercambio de datos",
  "privacy.s5.body": "Compartimos datos únicamente con los proveedores de servicios necesarios para operar la aplicación (alojamiento, análisis e inferencia de IA), y solo conforme a estrictos acuerdos de tratamiento de datos. Divulgaremos información cuando la ley lo exija, tras una revisión cuidadosa.",
  "privacy.s6.title": "6. Sus derechos",
  "privacy.s6.body": "Puede solicitar acceso a sus datos, su corrección o su eliminación en cualquier momento escribiendo a ek@stoicos.ai. Respetamos todos los derechos reconocidos por el RGPD, la CCPA y normativas similares, independientemente de dónde resida.",
  "privacy.s7.title": "7. Menores",
  "privacy.s7.body": "Virtue Guide está destinado a usuarios de 16 años o más. No recopilamos de forma consciente información de menores de 16 años.",
  "privacy.s8.title": "8. Cambios",
  "privacy.s8.body": "Podemos actualizar esta política periódicamente. Los cambios sustanciales se anunciarán en la aplicación y en stoicos.ai/privacy. El uso continuado de la aplicación después de dichas actualizaciones constituye su aceptación.",
  "privacy.s9.title": "9. Contacto",
  "privacy.s9.body": "Puede enviar sus preguntas, solicitudes o comentarios a ek@stoicos.ai. Procuramos responder en un plazo de 7 días hábiles.",
  "privacy.quote": "“Comience de inmediato a vivir, y considere cada día por separado como una vida por separado.”",
  "support.eyebrow": "Soporte",
  "support.headline1": "¿Cómo podemos",
  "support.headline2": "ayudarle?",
  "support.intro": "Somos un equipo pequeño y leemos personalmente cada mensaje. Puede esperar una respuesta en un plazo de dos días hábiles, por lo general mucho antes.",
  "support.emailLabel": "Escríbanos por correo",
  "support.pressLabel": "Prensa y medios",
  "support.readLabel": "Lea nuestra",
  "support.privacyValue": "Política de privacidad",
  "footer.termsLink": "Términos de uso",
  "support.writeTitle": "Escríbanos.",
  "support.writeSub": "Sin tickets ni chatbots. Solo una respuesta reflexiva.",
  "support.fieldName": "Su nombre",
  "support.fieldEmail": "Correo electrónico",
  "support.fieldTopic": "Tema",
  "support.fieldMessage": "Su mensaje",
  "support.topicGeneral": "Pregunta general",
  "support.topicAccount": "Cuenta",
  "support.topicBug": "Reportar un error",
  "support.topicPress": "Prensa y medios",
  "support.topicOther": "Otro",
  "support.placeholderName": "Marcus",
  "support.placeholderMessage": "Cuéntenos qué tiene en mente...",
  "support.submit": "Enviar mensaje",
  "support.sentTitle": "Su mensaje está en camino.",
  "support.sentBody": "Si su cliente de correo no se abrió, escriba a ",
  "support.faqTitle": "Preguntas frecuentes.",
  "support.faq1q": "¿Cuándo estará disponible Virtue Guide?",
  "support.faq1a": "Virtue Guide ya está disponible en la Apple App Store y en Google Play. Descargue la versión básica gratuita y comience hoy su viaje estoico.",
  "support.faq2q": "¿Es gratis?",
  "support.faq2a": "Los detalles de precios se compartirán en la aplicación en el lanzamiento.",
  "support.faq3q": "¿Cómo gestionan mis entradas del diario?",
  "support.faq3a": "Las entradas del diario se cifran en su dispositivo antes de sincronizarse. No podemos leerlas, ni siquiera en casos de soporte. Consulte nuestra Política de privacidad para conocer todos los detalles.",
  "support.faq4q": "¿Con qué filósofos puedo hablar?",
  "support.faq4a": "En el lanzamiento: Marco Aurelio, Séneca y Epicteto. Estamos explorando cuidadosamente voces adicionales: Musonio Rufo, Hierocles y también las escuelas helenísticas más allá de ellos.",
  "404.eyebrow": "404",
  "404.headline1": "El camino está",
  "404.headline2": "perdido.",
  "404.body": "“Si algo externo le causa angustia, el dolor no se debe a la cosa en sí, sino a su juicio sobre ella.” (Marco Aurelio)",
  "404.return": "Volver al inicio",
  "lang.switchTo": "Cambiar idioma",
  "hero.h2a": "Cultive la sabiduría. Fortalezca el carácter.",
  "hero.h2b": "Construya su Ciudadela Interior.",
  "hero.subtitleSeo": "Virtue Guide es un guía de sabiduría estoica impulsado por IA, inspirado en Marco Aurelio, Séneca y Epicteto, que le ayuda a desarrollar mejor juicio, resiliencia emocional y autoconocimiento.",
  "mission.quoteLead": "El conocimiento es barato.",
  "mission.quoteAccent": "La sabiduría no tiene precio.",
  "sages.eyebrow": "Conozca a los Sabios",
  "sages.introExtra": "La aplicación no trata sobre el estoicismo. Trata sobre el autoconocimiento. Conózcase a sí mismo. Los sabios son guías.",
  "sages.meetCta": "Conozca a {name}",
  "wivg.eyebrow": "¿Qué es Virtue Guide?",
  "wivg.h2a": "Un guía estoico con IA",
  "wivg.h2b": "para la vida examinada.",
  "wivg.intro": "Virtue Guide es el primer producto de StoicOs. No es una aplicación para leer sobre estoicismo, ni un flujo de citas, ni una aplicación de meditación. Es una práctica diaria pequeña y deliberada para volverse más sabio, más sereno y más usted mismo, con tres sabios, su propio diario privado y un guía de vida con IA guiado por la virtud.",
  "wivg.col1.title": "Qué hace",
  "wivg.col1.copy": "Virtue Guide es un guía de sabiduría estoica impulsado por IA. Usted conversa con guías inspirados en Marco Aurelio, Séneca y Epicteto, sabios que le ayudan a reflexionar sobre el día, examinar una decisión y advertir dónde puede elegir con mayor sabiduría.",
  "wivg.col2.title": "Cómo funciona",
  "wivg.col2.copy": "Cada día trae una breve reflexión y un diálogo opcional. La IA utiliza nuestro marco Common Sense by Virtue™ (Impresión, Razonamiento, Prueba de virtud, Asentimiento, Juicio, Elección, Acción, Reflexión) para ayudarle a convertir impresiones en juicios examinados.",
  "wivg.col3.title": "Por qué es diferente",
  "wivg.col3.copy": "La mayoría de las aplicaciones ofrecen contenido. Virtue Guide es una práctica. El objetivo no es más información. Es el autoconocimiento, un mejor juicio, la resiliencia emocional y el carácter. El conocimiento es barato. La sabiduría no tiene precio.",
  "csbv.eyebrow": "Common Sense by Virtue™",
  "csbv.h2a": "Un marco para",
  "csbv.h2b": "decisiones más sabias.",
  "csbv.intro": "La mayoría de las malas decisiones no provienen de una falta de inteligencia. Provienen de saltarse pasos: damos asentimiento a una primera impresión antes de haberla examinado. Common Sense by Virtue™ es el proceso estoico de toma de decisiones en ocho pasos por el que Virtue Guide le guía, hasta que se vuelva algo natural.",
  "csbv.step1.label": "Impresión",
  "csbv.step1.desc": "Advierta el primer pensamiento en bruto, antes de darlo por verdadero.",
  "csbv.step2.label": "Razonamiento",
  "csbv.step2.desc": "Examínelo. ¿Qué está diciendo realmente? ¿Es preciso?",
  "csbv.step3.label": "Prueba de virtud",
  "csbv.step3.desc": "Sabiduría · Valentía · Justicia · Templanza. ¿Se sostiene?",
  "csbv.step4.label": "Asentimiento",
  "csbv.step4.desc": "Solo ahora acepta (o rechaza) hacerlo suyo.",
  "csbv.step5.label": "Juicio",
  "csbv.step5.desc": "¿Cuál es la interpretación más precisa y honesta de la situación?",
  "csbv.step6.label": "Elección",
  "csbv.step6.desc": "Del juicio surge con claridad el siguiente paso correcto.",
  "csbv.step7.label": "Acción",
  "csbv.step7.desc": "Actúe con calma. El esfuerzo le pertenece; los resultados, no.",
  "csbv.step8.label": "Reflexión",
  "csbv.step8.desc": "Al final del día, examine lo que hizo. Ajuste. Repita.",
  "csbv.footQuote": "“Entre el estímulo y la respuesta hay un espacio. En ese espacio reside nuestro poder de elegir nuestra respuesta.”",
  "csbv.footAttrib": "La intuición estoica",
  "citadel.eyebrow": "La ciudadela interior",
  "citadel.h2a": "Construya la parte de usted",
  "citadel.h2b": "a la que nada externo puede alcanzar.",
  "citadel.intro": "Marco Aurelio escribió sobre una ciudadela interior: el juicio reflexivo de una persona, que ningún insulto, pérdida o golpe de fortuna puede quebrantar sin su consentimiento. Virtue Guide está construido en torno al fortalecimiento de esa ciudadela. Cada reflexión, cada pregunta estoica, cada conversación está al servicio de un desenlace sereno: una vida interior inconmovible.",
  "citadel.quote": "“Usted tiene poder sobre su mente, no sobre los acontecimientos externos. Comprenda esto y encontrará fortaleza.”",
  "citadel.quoteAttrib": "Marcus Aurelius",
  "citadel.pillar1.title": "Fortaleza interior",
  "citadel.pillar1.copy": "El núcleo sereno que no vacila cuando la vida llega sin aviso.",
  "citadel.pillar2.title": "Resiliencia emocional",
  "citadel.pillar2.copy": "No es la ausencia de sentimiento, sino la disciplina de no dejarse gobernar por él.",
  "citadel.pillar3.title": "Carácter",
  "citadel.pillar3.copy": "Lo que usted es cuando nadie mira, y cuando todos lo hacen.",
  "citadel.pillar4.title": "Estabilidad estoica",
  "citadel.pillar4.copy": "Una ecuanimidad que se mantiene, tanto si el día es excelente como si es ordinario o difícil.",
  "citadel.pillar5.title": "Dominio de sí",
  "citadel.pillar5.copy": "Gobierno de su propia atención, sus apetitos y su asentimiento: el único poder real.",
  "diff.eyebrow": "En qué se diferencia Virtue Guide",
  "diff.h2a": "No es otra aplicación de bienestar.",
  "diff.h2b": "Es una práctica de sabiduría.",
  "diff.intro": "Hay muchas aplicaciones excelentes de estoicismo y mindfulness. Las respetamos. Virtue Guide ocupa un lugar distinto: es un guía para la sabiduría, el carácter y el juicio, no una biblioteca de contenido, un registro del estado de ánimo, una herramienta de diario ni un temporizador de meditación. La comparación siguiente refleja con honestidad esa diferencia.",
  "diff.colApp": "Aplicación",
  "diff.colThem": "Lo que hacen",
  "diff.colUs": "Lo que hace Virtue Guide",
  "diff.row1.cat": "Aplicación de diario estoico",
  "diff.row1.them": "Indicaciones diarias para el diario, basadas en temas estoicos.",
  "diff.row1.us": "Diario + diálogo estoico con IA + marco de toma de decisiones Common Sense by Virtue™.",
  "diff.row2.cat": "Contenido estoico + seguimiento",
  "diff.row2.them": "Flujos de citas, seguimiento del estado de ánimo, diario, trabajo de respiración.",
  "diff.row2.us": "Un guía, no una biblioteca de contenido. Reflexión guiada por IA que examina sus decisiones reales.",
  "diff.row3.cat": "Boletín estoico y cursos",
  "diff.row3.them": "Citas y lecciones seleccionadas, para leer y asimilar.",
  "diff.row3.us": "No leer sobre el estoicismo, sino practicarlo, con tres sabios como sus guías de conversación.",
  "diff.row4.cat": "Meditación y filosofía secular",
  "diff.row4.them": "Meditación guiada y conversaciones reflexivas.",
  "diff.row4.us": "Menos sentarse en silencio, más pensar con claridad. Diseñado para las decisiones de su día real.",
  "diff.row5.cat": "Mindfulness y bienestar",
  "diff.row5.them": "Calma, sueño, ejercicios de mindfulness.",
  "diff.row5.us": "No es bienestar. Es una disciplina. Diseñado para desarrollar sabiduría y carácter, no solo relajación.",
  "diff.disclaimer": "Las aplicaciones y marcas se mencionan únicamente con fines de comparación conceptual. Todas las marcas comerciales pertenecen a sus respectivos propietarios.",
  "faq.eyebrow": "Preguntas frecuentes",
  "faq.h2a": "Preguntas",
  "faq.h2b": "que vale la pena plantear.",
  "faq.allLink": "Todas las preguntas",
  "faq.readMore": "Leer más",
  "faq.pageIntro": "Todo lo que quizá quiera saber sobre Virtue Guide: el guía estoico con IA, el marco que lo sustenta, la Ciudadela Interior y cómo una pequeña práctica diaria cambia la forma de una vida.",
  "faq.cta.eyebrow": "Comience la práctica",
  "faq.cta.h2a": "Comience su práctica con ",
  "faq.cta.h2b": "Virtue Guide.",
  "faq.cta.body": "Virtue Guide ya está disponible en el App Store y Google Play.",
  "faq.cta.aboutLink": "Acerca de StoicOs",
  "sub.backAria": "Volver al inicio de StoicOs Virtue Guide",
  "sub.commonQ": "Preguntas frecuentes",
  "sub.peopleAsk": "Otras preguntas frecuentes.",
  "sub.seeAllFaq": "Ver todas las preguntas",
  "sub.cta.eyebrow": "Comience la práctica",
  "sub.cta.h2a": "Comience su práctica con ",
  "sub.cta.h2b": "Virtue Guide.",
  "sub.cta.body": "Virtue Guide ya está disponible en el App Store y Google Play.",
  "compass.eyebrow": "La Brújula Estoica",
  "compass.headlineLead": "¿Tiene curiosidad por saber qué guía estoico",
  "compass.headlineAccent": "le aconsejaría hoy?",
  "compass.subheadline": "Responda cuatro preguntas breves y descubra qué maestro estoico se ajusta mejor al desafío que afronta en este momento.",
  "compass.startButton": "Hacer la Stoic Compass",
  "compass.meta": "Cuatro preguntas · Aproximadamente un minuto · Privado para usted",
  "compass.progressLabel": "Pregunta {n} de {total}",
  "compass.restartLabel": "Volver a empezar",
  "compass.takeAgain": "Hacer el compass de nuevo",
  "compass.reflectionLabel": "Reflexión",
  "compass.downloadEyebrow": "Comience la práctica",
  "compass.downloadHeadline": "Conozca a su guía en StoicOs.",
  "compass.q1.title": "Cuando la vida se siente difícil, ¿qué busca primero?",
  "compass.q1.a": "Dirección",
  "compass.q1.b": "Calma",
  "compass.q1.c": "Fortaleza",
  "compass.q2.title": "¿Qué le frustra más?",
  "compass.q2.a": "Falta de control",
  "compass.q2.b": "Falta de claridad",
  "compass.q2.c": "Actuar por debajo de mis valores",
  "compass.q3.title": "¿Qué cualidad admira más?",
  "compass.q3.a": "Autodisciplina",
  "compass.q3.b": "Sabiduría",
  "compass.q3.c": "Coraje",
  "compass.q4.title": "¿Qué necesita más hoy?",
  "compass.q4.a": "Perspectiva",
  "compass.q4.b": "Disciplina",
  "compass.q4.c": "Paz interior",
  "compass.bust.marcus": "Marcus Aurelius",
  "compass.bust.epictetus": "Epictetus",
  "compass.bust.seneca": "Seneca",
  "compass.quoteLabel": "Un consejo estoico",
  "compass.result.eyebrow": "Su guía estoico",
  "compass.result.marcus.name": "Marcus Aurelius",
  "compass.result.marcus.body": "Su compass apunta a Marcus Aurelius, el emperador filósofo. Usted busca perspectiva y una fortaleza serena: la mente firme que se mantiene estable cuando el peso de la responsabilidad aprieta.",
  "compass.result.marcus.quote": "Usted tiene poder sobre su mente, no sobre los acontecimientos externos. Comprenda esto y encontrará fortaleza.",
  "compass.result.marcus.quoteAttrib": "Marcus Aurelius, Meditations",
  "compass.result.marcus.cta": "Comience su práctica con Marcus",
  "compass.result.seneca.name": "Seneca",
  "compass.result.seneca.body": "Su compass apunta a Seneca, el estadista y autor de cartas. Usted busca dirección, disciplina y la sabiduría para convertir la intención en una acción íntegra.",
  "compass.result.seneca.quote": "No es que tengamos poco tiempo para vivir, sino que desperdiciamos gran parte de él.",
  "compass.result.seneca.quoteAttrib": "Seneca, Letters from a Stoic",
  "compass.result.seneca.cta": "Comience su práctica con Seneca",
  "compass.result.epictetus.name": "Epictetus",
  "compass.result.epictetus.body": "Su compass apunta a Epictetus, el esclavo liberado convertido en maestro. Usted busca la libertad interior que nace de concentrarse solo en lo que verdaderamente está bajo su control.",
  "compass.result.epictetus.quote": "Algunas cosas están bajo nuestro control y otras no.",
  "compass.result.epictetus.quoteAttrib": "Epicteto, Enchiridion",
  "compass.result.epictetus.cta": "Comience su práctica con Epicteto",
  "gs.title": "Primeros pasos",
  "gs.eyebrow": "Un breve recorrido",
  "gs.intro": "Seis puertas de entrada a la Stoa digital. Comience donde se sienta llamado.",
  "gs.open": "Abrir guía",
  "gs.close": "Cerrar guía",
  "gs.virtueguide.title": "Virtue Guide",
  "gs.virtueguide.desc": "Dialogue con Marco Aurelio, Séneca y Epicteto.",
  "gs.journal.title": "The Stoic Journal",
  "gs.journal.desc": "Lea artículos, reflexiones y sabiduría práctica.",
  "gs.cards.title": "Tarjetas de práctica estoica",
  "gs.cards.desc": "Practique ejercicios estoicos para la vida cotidiana.",
  "gs.insights.title": "Mis reflexiones",
  "gs.insights.desc": "Explore reflexiones personales y lecciones aprendidas.",
  "gs.books.title": "Mis libros",
  "gs.books.desc": "Descubra los libros que sostienen este camino.",
  "gs.about.title": "Acerca de StoicOs.ai",
  "gs.about.desc": "Conozca la misión y al fundador.",
  "journal.eyebrow": "The Stoic Journal",
  "journal.title": "The Stoic Journal",
  "journal.subA": "Textos antiguos.",
  "journal.subB": "Reflexiones modernas.",
  "journal.subC": "Preguntas atemporales.",
  "journal.intro": "Una pequeña biblioteca editorial de artículos, ensayos y reflexiones. Se añaden nuevas entradas a medida que la práctica se profundiza.",
  "journal.comingSoon": "Se están escribiendo los primeros artículos. Vuelva pronto, o suscríbase abajo para recibir una serena nota cuando se publiquen los primeros ensayos.",
  "journal.categoriesLabel": "Categorías",
  "journal.cat.all": "Todas",
  "journal.cat.marcus": "Marco Aurelio",
  "journal.cat.epictetus": "Epicteto",
  "journal.cat.seneca": "Séneca",
  "journal.cat.stoicPractice": "Práctica estoica",
  "journal.cat.virtues": "Virtudes",
  "journal.cat.modernLife": "Vida moderna",
  "journal.cat.stoicismSociety": "Estoicismo y sociedad",
  "journal.cat.virtueGuide": "Virtue Guide",
  "journal.cat.stoicism": "Estoicismo",
  "journal.cat.selfKnowledge": "Autoconocimiento",
  "journal.cat.reflections": "Reflexiones",
  "journal.featuredLabel": "Destacado",
  "journal.featuredTitle": "Cómo la sabiduría antigua me ayudó a atravesar un período difícil",
  "journal.featuredAuthor": "Eduard Korporaal",
  "journal.featuredRole": "Fundador, StoicOs.ai",
  "journal.featuredTeaser": "Un relato personal sobre el regreso a los estoicos en una etapa en la que poco más ofrecía sostén. Un ensayo sobre la labor lenta y serena de llegar a ser una persona más sabia.",
  "journal.featuredReadCta": "Leer el artículo",
  "journal.browseLabel": "Explorar",
  "journal.search.placeholder": "Buscar en la Stoic Library…",
  "journal.hero.label": "The Stoic Journal",
  "journal.hero.title": "Textos antiguos. Reflexiones modernas. Preguntas atemporales.",
  "journal.hero.tagline": "Textos antiguos. Reflexiones modernas. Preguntas atemporales.",
  "journal.hero.lede": "Una biblioteca editorial de artículos, ensayos y reflexiones para la vida moderna.",
  "journal.hero.cta": "Explorar The Stoic Journal",
  "journal.search.results": "resultados",
  "journal.tags.philosophers": "Filósofos",
  "journal.tags.themes": "Temas",
  "journal.tags.virtues": "Virtudes",
  "journal.tags.practices": "Prácticas",
  "journal.readingTime": "min de lectura",
  "journal.readMore": "Seguir leyendo",
  "journal.empty.title": "Todavía no hay artículos en esta categoría.",
  "journal.empty.body": "Hay más textos en camino. Explore otra categoría o espere en calma. La labor continúa.",
  "journal.backToIndex": "Volver a The Stoic Journal",
  "journal.article.publishedOn": "Publicado",
  "journal.article.readOther": "Otros artículos",
  "journal.article.relatedTitle": "Artículos relacionados",
  "journal.article.tagsLabel": "Etiquetas",
  "journal.cta.eyebrow": "Continúe su práctica",
  "journal.cta.title": "Continúe su práctica en Virtue Guide.",
  "journal.cta.body": "La edición básica gratuita está a su disposición. Comience hoy su camino estoico.",
  "journal.cta.download": "Descarga gratuita",
  "cards.eyebrow": "Tarjetas de práctica estoica",
  "cards.title": "Tarjetas de práctica estoica",
  "cards.subtitle": "Para la vida diaria",
  "cards.lede": "Sabiduría que puede llevar en el bolsillo.",
  "cards.intro": "Breves ejercicios estoicos, tomados de los clásicos y adaptados a nuestra manera de vivir hoy. Prácticos, repetibles, hechos para acompañarle a lo largo del día.",
  "cards.comingSoon": "Las primeras 23 tarjetas están siendo afinadas. Vuelva pronto para leerlas, descargarlas y compartirlas.",
  "cards.browseLabel": "Explorar por",
  "cards.shown": "tarjetas mostradas",
  "cards.cat.all": "Todas",
  "cards.cat.virtue": "Virtud",
  "cards.cat.emotion": "Emoción",
  "cards.cat.philosophy": "Filosofía",
  "cards.cat.wisdom": "Sabiduría",
  "cards.cat.courage": "Valentía",
  "cards.cat.justice": "Justicia",
  "cards.cat.temperance": "Templanza",
  "cards.cat.relationships": "Relaciones",
  "cards.cat.work": "Trabajo",
  "cards.cat.selfKnowledge": "Autoconocimiento",
  "cards.cat.difficultTimes": "Tiempos difíciles",
  "cards.downloadCard": "Descargar tarjeta",
  "cards.shareCard": "Compartir tarjeta",
  "cards.empty.title": "Aún no hay tarjetas en esta categoría.",
  "cards.empty.body": "La biblioteca crece con las estaciones. Pruebe otra categoría o vuelva pronto.",
  "cards.modal.close": "Cerrar",
  "cards.share.download": "Descargar PNG",
  "cards.share.downloaded": "Descargado",
  "cards.share.native": "Compartir…",
  "cards.share.shareTo": "Compartir en",
  "cards.share.copyLink": "Copiar enlace",
  "cards.share.linkCopied": "Enlace copiado",
  "cards.share.instagramHint": "Tarjeta guardada. Abra Instagram y publique la imagen desde sus fotos.",
  "insights.eyebrow": "Mis reflexiones",
  "insights.title": "Mis reflexiones",
  "insights.subtitle": "Reflexiones de un estoico moderno.",
  "insights.intro": "Reflexiones personales y lecciones aprendidas. No son citas estoicas, sino notas pequeñas y sinceras de una vida dedicada a intentar vivirlas.",
  "insights.byline": "Por Ed Korporaal",
  "insights.comingSoon": "Las primeras reflexiones se están escribiendo a mano. Se añadirán nuevas entradas discretamente a medida que lleguen.",
  "insights.shareLabel": "Compartir",
  "books.eyebrow": "Mis libros",
  "books.title": "Mis libros",
  "books.subtitle": "Un viaje personal a través de la sabiduría antigua.",
  "books.intro": "La biblioteca detrás de la práctica: ediciones antiguas sostenidas entre las manos, traducciones modernas leídas hasta altas horas de la noche, textos de dominio público accesibles para cualquiera y algunos libros raros que aún siguen en búsqueda.",
  "books.comingSoon": "Cada libro está siendo fotografiado y anotado. Los primeros estantes aparecerán aquí pronto.",
  "books.s1.title": "Obras antiguas",
  "books.s1.desc": "Ediciones antiguas sostenidas entre las manos, pequeñas ventanas a cómo lectores de otras épocas se acercaron a estos textos.",
  "books.s1.b1.title": "Enchiridion",
  "books.s1.b1.year": "1670 / 1680",
  "books.s1.b1.note": "Una edición impresa temprana del Enchiridion de Epicteto, el pequeño manual que ha guiado a los lectores durante casi dos milenios.",
  "books.s1.b2.title": "Stoicos Apatheias",
  "books.s1.b2.year": "Edición histórica",
  "books.s1.b2.note": "Una edición histórica que recorre la doctrina estoica de la apatheia: la libertad de no ser gobernado por las pasiones.",
  "books.s2.title": "Estoicismo moderno",
  "books.s2.desc": "Los libros que actualmente se poseen y estudian. Una colección en expansión.",
  "books.s2.b1": "Meditaciones · Marco Aurelio",
  "books.s2.b2": "Cartas de un estoico · Séneca",
  "books.s2.b3": "The Practicing Stoic · Ward Farnsworth",
  "books.s2.b4": "How to Think Like a Roman Emperor · Donald Robertson",
  "books.s2.b5": "Otros títulos de la colección personal de Ed",
  "books.s3.title": "Textos estoicos esenciales",
  "books.s3.desc": "Obras de dominio público disponibles para cualquier persona. Un buen punto de partida para la práctica.",
  "books.s3.whyMatters": "Por qué importa",
  "books.s3.readOnline": "Leer en línea",
  "books.s3.b1.title": "Meditaciones",
  "books.s3.b1.author": "Marco Aurelio",
  "books.s3.b1.why": "El cuaderno privado de un emperador, escrito para sí mismo, no para nosotros. La entrada más clara al estoicismo vivido.",
  "books.s3.b1.url": "https://www.gutenberg.org/ebooks/2680",
  "books.s3.b2.title": "Enquiridión",
  "books.s3.b2.author": "Epicteto",
  "books.s3.b2.why": "Un manual breve sobre lo que está en nuestro poder y lo que no. El camino más corto hacia la disciplina estoica.",
  "books.s3.b2.url": "https://www.gutenberg.org/ebooks/45109",
  "books.s3.b3.title": "Cartas a Lucilio",
  "books.s3.b3.author": "Séneca",
  "books.s3.b3.why": "Una larga correspondencia sobre cómo vivir: cálida, elocuente y lo más parecido que puede ser un libro a un amigo mayor y sabio.",
  "books.s3.b3.url": "https://www.gutenberg.org/ebooks/56075",
  "books.s4.title": "En mi búsqueda",
  "books.s4.desc": "Libros que Ed aún espera adquirir, en una búsqueda de toda la vida de ediciones que señalan el recorrido del estoicismo a través de la historia.",
  "books.s4.b1": "Ediciones raras de Marco Aurelio",
  "books.s4.b2": "Ediciones raras de Séneca",
  "books.s4.b3": "Obras de Justo Lipsio",
  "books.s4.b4": "Otros textos estoicos históricos",
  "placeholder.notifyTitle": "Reciba una notificación discreta",
  "placeholder.notifyBody": "Deje su correo electrónico y le escribiremos una sola vez cuando esta sección se abra. Sin ruido.",
  "placeholder.notifyButton": "Avíseme",
  "placeholder.exploreOther": "Explore el resto de The Stoa",
  "agora.hero.eyebrow": "Stoic Os · Agora",
  "agora.hero.title": "Entre en The Stoa",
  "agora.hero.subtitle": "Antes de aprender The Stoa, debe sentirla.",
  "agora.hero.line1": "Aprenda sabiduría.",
  "agora.hero.line2": "Practique la virtud.",
  "agora.hero.line3": "Viva bien.",
  "agora.hero.cta": "Comience el viaje",
  "agora.hero.scroll": "Entre",
  "agora.hero.alt": "Panorama bañado por el sol de la antigua Atenas: columnata de mármol, ciudadanos en el Agora, la Acrópolis coronando la ciudad bajo la luz dorada del atardecer.",
  "agora.intro": "Antes de aprender la Stoa, debe sentirla. Camine despacio. Aquí no hay un plan de estudios. Solo hay una larga sala de luz y una pregunta que le espera desde Atenas: ¿cómo debería vivir?",
  "agora.continueJourney": "Continúe el viaje",
  "agora.readMore": "Leer más",
  "agora.placeholder": "Próximamente. Este lugar se está construyendo. La sabiduría vendrá después.",
  "agora.s1.numeral": "II",
  "agora.s1.title": "El amanecer griego",
  "agora.s1.dates": "334 – 206 a. C.",
  "agora.s1.figures": "Zenón de Citio · Cleantes · Crisipo",
  "agora.s1.atmosphere": "La luz de la mañana sobre Atenas. Olivos. Columnas de mármol. El comienzo de la Stoa.",
  "agora.s1.body": "Un mercader náufrago entra en una librería de Atenas y nunca vuelve a marcharse. La escuela que funda recibe su nombre del pórtico pintado donde enseña al aire libre, la stoa poikilē. Cualquiera puede escuchar. La primera filosofía de la vida cotidiana nace bajo un techo de luz de olivo.",
  "agora.s1.alt": "Zenón de Citio enseña a estudiantes sentados sobre losas de mármol bajo una columnata. La Acrópolis se alza al atardecer, enmarcada por ramas de olivo.",
  "agora.stoa.numeral": "III",
  "agora.stoa.title": "La Stoa Poikile",
  "agora.stoa.subtitle": "La escuela de la razón",
  "agora.stoa.atmosphere": "Bajo el pórtico pintado. Frescos cálidos bajo la luz de la tarde. Voces, luego voces más suaves, luego una pregunta.",
  "agora.stoa.q1": "Sin misterios sagrados.",
  "agora.stoa.q2": "Sin doctrinas ocultas.",
  "agora.stoa.q3": "Solo observación.",
  "agora.stoa.q4": "Solo diálogo.",
  "agora.stoa.q5": "Solo razón.",
  "agora.stoa.p1": "Bajo el pórtico pintado de Atenas, la gente se reunía no para rendir culto, sino para pensar. Los mercaderes se sentaban junto a los estudiantes. Los ciudadanos debatían con los viajeros. Las preguntas eran bienvenidas. Los argumentos se ponían a prueba. Las ideas eran cuestionadas.",
  "agora.stoa.p2": "La Stoa no se edificó sobre la revelación ni sobre la autoridad. Se edificó sobre la razón.",
  "agora.stoa.p3": "Aquí, la sabiduría no se transmitía. Se descubría en común.",
  "agora.stoa.alt": "El pórtico pintado de la antigua Atenas en la hora dorada. Ciudadanos, estudiantes, viajeros y un filósofo anciano en animado diálogo bajo muros con frescos y columnas de mármol; la Acrópolis visible al fondo.",
  "agora.cleanthes.numeral": "IV",
  "agora.cleanthes.dates": "331 – 232 a. C.",
  "agora.cleanthes.title": "Cleantes",
  "agora.cleanthes.subtitle": "Disciplina y devoción",
  "agora.cleanthes.virtues": "Disciplina · Perseverancia · Humildad · Devoción",
  "agora.cleanthes.q1": "Donde Zenón abrió la puerta,",
  "agora.cleanthes.q2": "Cleantes permaneció cuando otros se fueron.",
  "agora.cleanthes.p1": "Después de Zenón llegó la prueba de la perseverancia.",
  "agora.cleanthes.p2": "Cleantes no nació en la riqueza. Trabajaba de noche cargando agua por las calles de Atenas y estudiaba filosofía de día.",
  "agora.cleanthes.p3": "Otros admiraban la sabiduría. Cleantes la practicaba. Creía que el carácter se forja mediante la disciplina, el esfuerzo y la fidelidad a lo que es correcto.",
  "agora.cleanthes.p4": "Bajo su guía, la Stoa se convirtió en algo más que una idea. Se convirtió en una forma de vida.",
  "agora.cleanthes.alt": "Cleantes se dirige a sus discípulos bajo la columnata de la Stoa. Toga en tonos terrosos, columnas de mármol, muro con frescos, la Acrópolis visible entre las columnas bajo la luz dorada de la tarde.",
  "agora.chrysippus.numeral": "V",
  "agora.chrysippus.dates": "279 – 206 a. C.",
  "agora.chrysippus.title": "Crisipo",
  "agora.chrysippus.subtitle": "El sistema de la razón",
  "agora.chrysippus.note": "Crisipo de Solos · Tercer director de la escuela estoica · A menudo llamado “el segundo fundador del estoicismo”",
  "agora.chrysippus.concepts": "Impresión · Razonamiento · Asentimiento · Juicio · Acción",
  "agora.chrysippus.q1": "Para vivir bien,",
  "agora.chrysippus.q2": "primero hay que aprender a pensar con claridad.",
  "agora.chrysippus.p1": "Atenas estaba llena de opiniones. El puerto estaba lleno de mercaderes, marineros, políticos y filósofos. Todos tenían un punto de vista. No todo punto de vista era verdadero.",
  "agora.chrysippus.p2": "Crisipo creía que la sabiduría comienza cuando las impresiones se examinan en lugar de aceptarse ciegamente. En mesas concurridas y bajo el ruido de la ciudad, los argumentos se ponían a prueba. Las preguntas eran cuestionadas. Los supuestos quedaban al descubierto.",
  "agora.chrysippus.p3": "La razón se convirtió en un instrumento de libertad. Lo que importa no es lo que parece verdadero. Lo que importa es lo que resiste el examen.",
  "agora.chrysippus.p4": "Con Crisipo, el estoicismo ganó su estructura. Mediante la razón, la filosofía se volvió práctica.",
  "agora.chrysippus.alt": "Un filósofo anciano con toga clara gesticula en medio de un argumento junto a una mesa de madera, al borde del puerto. Tres compañeros se inclinan para escuchar. Detrás de ellos: barcos atracados, un mercado rebosante y la Acrópolis coronando la ciudad en la luz dorada del atardecer.",
  "agora.bridge.numeral": "VI",
  "agora.bridge.dates": "c. 185 – 110 a. C.",
  "agora.bridge.title": "El puente hacia Roma",
  "agora.bridge.subtitle": "Cuando la sabiduría griega encontró el poder romano",
  "agora.bridge.note": "Panecio de Rodas · c. 185 – 110 a. C. · Filósofo estoico · Maestro y consejero de influyentes estadistas romanos · Ampliamente considerado el filósofo que introdujo el estoicismo en la élite romana",
  "agora.bridge.concepts": "Sabiduría · Carácter · Deber · Cultura · Civilización",
  "agora.bridge.q1": "Roma conquistó Grecia con legiones.",
  "agora.bridge.q2": "Grecia conquistó Roma con ideas.",
  "agora.bridge.p1": "El Mediterráneo pertenecía ahora a Roma. Sus legiones custodiaban los puertos. Sus senadores gobernaban una república en expansión. Sus estandartes ondeaban por todo el mundo conocido. El poder había elegido su capital.",
  "agora.bridge.p2": "Y, sin embargo, en esta época de conquista ocurrió algo inesperado. Los conquistadores se volvieron discípulos. Los estadistas romanos miraron más allá de la riqueza, más allá de la victoria militar y más allá de la política. Miraron hacia Grecia, no en busca de tierras ni de oro, sino de sabiduría.",
  "agora.bridge.p3": "Panecio de Rodas se encontraba entre dos civilizaciones. A su espalda quedaba Atenas. Ante él se alzaba Roma. No llevaba ejército. Ni flota. Ni autoridad. Solo ideas: sobre el carácter, sobre el deber, sobre la razón, sobre la virtud.",
  "agora.bridge.p4": "Con Panecio, el estoicismo cruzó el mar. La filosofía nacida bajo el pórtico pintado de Atenas comenzó su viaje hacia el corazón de Roma. Bajo la mirada vigilante de soldados y senadores, surgió otra clase de poder: el poder de una vida examinada. La espada había conquistado territorios. Las ideas conquistarían siglos.",
  "agora.bridge.alt": "Un filósofo griego con toga clara se dirige a un círculo de senadores romanos y a un centurión junto a una mesa de piedra, en el puerto, al atardecer. Buques de guerra romanos enarbolan un estandarte con un águila; columnas y estatuas bordean el muelle; la ciudad de Roma se eleva a lo lejos.",
  "agora.seneca.numeral": "VII",
  "agora.seneca.dates": "4 a. C. – 65 d. C.",
  "agora.seneca.title": "Séneca",
  "agora.seneca.subtitle": "Sabiduría en medio del poder",
  "agora.seneca.note": "Lucio Anneo Séneca · 4 a. C. – 65 d. C. · Filósofo estoico romano · Estadista · Autor de las Cartas a Lucilio · Consejero del emperador Nerón · Una de las voces más influyentes del estoicismo",
  "agora.seneca.concepts": "Virtud · Fortuna · Carácter · Mortalidad · Libertad interior",
  "agora.seneca.q1": "No es pobre el hombre que tiene muy poco,",
  "agora.seneca.q2": "sino el hombre que ansía más,",
  "agora.seneca.q3": "quien es pobre.",
  "agora.seneca.qattr": "Séneca",
  "agora.seneca.p1": "Roma era ya el centro del mundo. Sus caminos cruzaban continentes. Sus ejércitos custodiaban un imperio. Sus gobernantes ejercían un poder inmenso. Y, sin embargo, bajo la grandeza de mármol de Roma se desplegaba otra lucha: la lucha interior.",
  "agora.seneca.p2": "Séneca vivió cerca del poder. Más cerca de lo que la mayoría de los filósofos jamás se atrevió. Aconsejó a emperadores. Acumuló riqueza. Se movió entre palacios y cortes. Y, sin embargo, sus escritos volvían una y otra vez a la misma pregunta: ¿cómo puede una persona seguir siendo libre?",
  "agora.seneca.p3": "En sus Cartas a Lucilio, Séneca hablaba no como un maestro distante, sino como un compañero. Escribía sobre el miedo. Sobre la ira. Sobre la fortuna. Sobre la muerte. Sobre la práctica cotidiana de la filosofía. Su sabiduría no estaba destinada a las escuelas. Estaba destinada a la vida.",
  "agora.seneca.p4": "A medida que el reinado de Nerón se fue oscureciendo, Séneca se retiró gradualmente de la vida pública. Tras la conspiración de Pisón del año 65 d. C., fue acusado de estar implicado. Que fuera culpable o inocente sigue siendo incierto. Nerón le ordenó poner fin a su propia vida. Séneca obedeció con serenidad. El filósofo que tan a menudo había escrito sobre la mortalidad se enfrentaba ahora a ella en persona.",
  "agora.seneca.p5": "Su última lección no fue escrita. Fue vivida.",
  "agora.seneca.alt": "Séneca escribiendo en una mesa de piedra en el jardín de su villa al atardecer. Cipreses, una columnata cubierta de hiedra, estatuas de mármol, un estanque de aguas tranquilas y la ciudad de Roma elevándose a lo lejos bajo la luz dorada del atardecer.",
  "agora.epictetus.numeral": "VIII",
  "agora.epictetus.dates": "c. 50–135 d. C.",
  "agora.epictetus.title": "Epicteto",
  "agora.epictetus.subtitle": "La libertad interior",
  "agora.epictetus.note": "Epicteto · c. 50–135 d. C. · Nació esclavo · Más tarde fue uno de los maestros estoicos más influyentes de la historia · Sus enseñanzas han perdurado a través de los Discourses y el Enchiridion, recogidos por Arriano",
  "agora.epictetus.concepts": "Libertad · Dominio de sí · Disciplina · Aceptación · Carácter",
  "agora.epictetus.q1": "Ningún ser humano es libre si no es dueño de sí mismo.",
  "agora.epictetus.qattr": "Epicteto",
  "agora.epictetus.p1": "Epicteto nació esclavo. No poseía nada. Su futuro pertenecía a otros. Su cuerpo podía ser sometido a órdenes. Sus movimientos, controlados. Su vida, dirigida por la voluntad de otro hombre. Y, sin embargo, incluso siendo esclavo, descubrió algo que ningún amo podía arrebatarle: la libertad de la mente.",
  "agora.epictetus.p2": "Después de obtener su libertad, Epicteto se convirtió en maestro. No en palacios. No en el Senado. No entre los ricos. Sino entre personas corrientes que buscaban una mejor manera de vivir.",
  "agora.epictetus.p3": "Su mensaje era sencillo. Algunas cosas están bajo nuestro control. Otras no. La confusión comienza cuando confundimos una con la otra. La paz comienza cuando aprendemos la diferencia.",
  "agora.epictetus.p4": "Los estudiantes recorrían grandes distancias para escucharlo hablar. No acudían por teorías. Acudían por claridad. Por valentía. Por sabiduría práctica. Por una manera de mantenerse firmes en un mundo incierto.",
  "agora.epictetus.p5": "Epicteto enseñaba que la libertad no procede de la riqueza. Ni del estatus. Ni del poder. Procede del gobierno de uno mismo. La persona que domina sus juicios se vuelve inconquistable.",
  "agora.epictetus.p6": "Su discípulo Arriano dejó constancia de sus enseñanzas. A través de esos escritos, la voz de un antiguo esclavo resonaría a lo largo de los siglos, hasta llegar finalmente a un emperador llamado Marco Aurelio.",
  "agora.epictetus.alt": "Epicteto, curtido por los años y de barba canosa, está sentado ante una mesa baja de madera cubierta de rollos y pequeñas tablillas de madera, con un dedo alzado mientras enseña. Sus estudiantes se inclinan hacia él con togas en tonos terrosos. Cadenas de hierro cuelgan de la pared agrietada a su espalda; a través del arco abierto, el templo de una antigua ciudad de montaña resplandece bajo la luz dorada del atardecer.",
  "agora.marcus.numeral": "IX",
  "agora.marcus.dates": "121–180 d. C.",
  "agora.marcus.title": "Marco Aurelio",
  "agora.marcus.subtitle": "El filósofo",
  "agora.marcus.note": "Marco Aurelio · 121–180 d. C. · Emperador romano · Estudiante del estoicismo · Heredero adoptivo de Antonino Pío · Autor de las Meditaciones · Ampliamente considerado uno de los gobernantes más sabios de la historia",
  "agora.marcus.concepts": "Carácter · Deber · Humildad · Filosofía · Servicio",
  "agora.marcus.q1": "No pierda más tiempo discutiendo cómo debe ser una buena persona.",
  "agora.marcus.q2": "Séalo.",
  "agora.marcus.qattr": "Marco Aurelio",
  "agora.marcus.p1": "Marco Aurelio nació en 121 d. C. como Marco Annio Vero. Desde muy temprana edad, quienes lo rodeaban advirtieron algo inusual. Seriedad. Sinceridad. Una serena devoción al deber.",
  "agora.marcus.p2": "El emperador Adriano también vio esas cualidades. Según se dice, dio al muchacho un apodo: Verissimus, “el más veraz”, “el más recto”. No por ambición. No por estatus. Sino por carácter.",
  "agora.marcus.p3": "El futuro de Marco cambió cuando Adriano adoptó a Antonino Pío y le exigió que adoptara a dos jóvenes herederos: Marco Aurelio y Lucio Vero. El camino hacia el trono fue elegido para él. Sin embargo, Marco nunca consideró el cargo imperial como una recompensa. Lo consideró una responsabilidad.",
  "agora.marcus.p4": "De joven se sumergió en la filosofía. Entre todos sus maestros, uno se destacó por encima de los demás: Junio Rústico. Más tarde, Marco agradecería a Rústico en sus Meditaciones por haberlo introducido en las enseñanzas de Epicteto y por haberle mostrado el valor de la sencillez, la humildad y el examen de sí mismo.",
  "agora.marcus.p5": "Después vinieron otros maestros. Apolonio de Calcedonia. Sexto de Queronea. Frontón, el gran retórico. Cada uno formó su mente. Pero fue el estoicismo lo que formó su carácter.",
  "agora.marcus.p6": "Desde lo alto de Roma, Marco contemplaba la mayor ciudad del mundo. Sin embargo, su atención se dirigía a otra parte. No al poder. No a la gloria. No a la riqueza. Sino a una pregunta que guiaría toda su vida: ¿cómo debe vivir un ser humano?",
  "agora.marcus.alt": "Un joven Marco Aurelio, de cabello oscuro y rizado, con túnica color crema y una capa púrpura intensa bordada en oro, está de pie en un balcón de mármol con vista a la ciudad de Roma al atardecer. Cúpulas, columnas y tejados se extienden hasta el horizonte bajo un vasto cielo dorado.",
  "agora.marcusWar.numeral": "X",
  "agora.marcusWar.dates": "161–180 d. C. · Las guerras marcomanas",
  "agora.marcusWar.title": "Marco Aurelio",
  "agora.marcusWar.subtitle": "El filósofo en la guerra",
  "agora.marcusWar.note": "Marco Aurelio · 121–180 d. C. · Emperador romano · Filósofo estoico · Comandante de las legiones romanas en la frontera del Danubio · Autor de las Meditaciones · Ampliamente considerado uno de los gobernantes más sabios de la historia.",
  "agora.marcusWar.concepts": "Guerra · Reflexión · Razón · Disciplina · Virtud",
  "agora.marcusWar.q1": "El obstáculo para la acción impulsa la acción.",
  "agora.marcusWar.q2": "Lo que se interpone en el camino se convierte en el camino.",
  "agora.marcusWar.qattr": "Marcus Aurelius",
  "agora.marcusWar.p1": "El imperio estaba en guerra. A lo largo de la frontera del Danubio, las legiones romanas afrontaban una presión incesante de las tribus al otro lado del río. El invierno era duro. Los suministros eran inciertos. Miles dependían de las decisiones de un solo hombre. Ese hombre era Marcus Aurelius.",
  "agora.marcusWar.p2": "De día comandaba ejércitos. De noche se comandaba a sí mismo. En el silencio de su tienda de mando, iluminada solo por lámparas de aceite y el resplandor de las hogueras lejanas del campamento, Marcus escribía reflexiones privadas. No para ser publicadas. No para la historia. No para la fama. Solo para sí mismo.",
  "agora.marcusWar.p3": "Estas notas llegarían a conocerse como las Meditaciones. Uno de los libros más extraordinarios jamás escritos. No porque enseñe a gobernar un imperio, sino porque enseña a gobernarse a sí mismo.",
  "agora.marcusWar.p4": "Afuera estaban los ejércitos de Roma. Adentro estaba un hombre que intentaba seguir siendo bueno.",
  "agora.marcusWar.p5": "La mayor batalla de Marcus Aurelius no se libró contra los marcomanos. Se libró en su interior.",
  "agora.marcusWar.alt": "Marcus Aurelius, con armadura de bronce y capa carmesí, escribe a la luz de una lámpara dentro de su tienda de mando en la frontera del Danubio al anochecer. Más allá de la abertura de la tienda, las legiones romanas permanecen formadas junto al río bajo un cielo naranja encendido; detrás de él, en la pared de la tienda, cuelgan mapas y estandartes.",
  "agora.marcusEnd.numeral": "XI",
  "agora.marcusEnd.dates": "180 d. C. · El último día",
  "agora.marcusEnd.title": "Marcus Aurelius",
  "agora.marcusEnd.subtitle": "La última puesta del sol",
  "agora.marcusEnd.note": "Marcus Aurelius · 121–180 d. C. · Emperador romano · Filósofo estoico · Autor de las Meditaciones. Murió durante las campañas del Danubio en 180 d. C. Las últimas palabras aquí presentadas pertenecen a una tradición histórica posterior y reflejan el espíritu estoico por el que Marcus Aurelius llegó a ser conocido.",
  "agora.marcusEnd.concepts": "Amor Fati · Aceptación · Naturaleza · Logos · Mortalidad",
  "agora.marcusEnd.q1": "No actúe como si fuera a vivir diez mil años.",
  "agora.marcusEnd.q2": "La muerte pende sobre usted.",
  "agora.marcusEnd.q3": "Mientras viva, mientras esté en su poder, sea bueno.",
  "agora.marcusEnd.qattr": "Marcus Aurelius",
  "agora.marcusEnd.p1": "Las guerras estaban llegando a su fin. Las campañas estaban casi concluidas. Las cargas del imperio se habían llevado durante muchos años. Marcus Aurelius había pasado toda una vida al servicio de algo mayor que él mismo. Ahora le aguardaba otro deber.",
  "agora.marcusEnd.p2": "La edad había debilitado su cuerpo. La pérdida lo había visitado muchas veces. Había soportado peste, hambre, guerra, intrigas políticas y la muerte de muchos de aquellos a quienes amaba. Y, sin embargo, a través de todo ello volvía siempre a los mismos principios. Razón. Deber. Virtud. Aceptación.",
  "agora.marcusEnd.p3": "Cuando se acercaba el amanecer, Marcus descansaba en su estancia. Más allá del balcón, la primera luz rozaba el horizonte. El imperio despertaba. Un nuevo día comenzaba.",
  "agora.marcusEnd.p4": "Según una tradición posterior, Marcus mandó llamar a un guardia pretoriano. El joven soldado entró. Marcus miró hacia el sol naciente, y luego hacia el hombre cuya vida aún se extendía ante él. Y pronunció unas palabras que han resonado a través de los siglos.",
  "agora.marcusEnd.p5": "“Vaya ahora. Para usted, el sol está saliendo. Para mí, se está poniendo.”",
  "agora.marcusEnd.p6": "No había amargura. No había miedo. No había resistencia. Solo aceptación: la aceptación de un hombre que comprendía que todo lo tomado en préstamo de la Naturaleza debe un día ser devuelto.",
  "agora.marcusEnd.p7": "Para Marcus, la muerte no era un enemigo. Formaba parte del mismo orden que le había dado la vida. El mismo Logos. El mismo universo. El mismo proceso eterno de llegar a ser y desaparecer.",
  "agora.marcusEnd.p8": "El filósofo que había pasado toda una vida preparándose para este momento lo encontró ahora con calma. Como había vivido, así partió.",
  "agora.marcusEnd.closing": "El sol sale. El sol se pone. El Logos permanece.",
  "agora.marcusEnd.alt": "Un Marcus Aurelius anciano reposa en un lecho imperial cubierto de seda, en una estancia de mármol al atardecer. Con la mano abierta, hace un gesto hacia un guardia pretoriano que está junto al balcón abierto. Más allá de las columnas, Roma se extiende hasta el horizonte bajo un vasto cielo dorado; sobre una mesa baja descansan una lámpara de aceite encendida y un códice de cuero con la inscripción ‘Meditationes · Marcus Aurelius’.",
  "agora.s2.numeral": "IV",
  "agora.s2.title": "El sistema de la razón",
  "agora.s2.figures": "Chrysippus",
  "agora.s2.themes": "Impresiones · Razonamiento · Juicio · Lógica",
  "agora.s2.atmosphere": "Rollos. Mapas. Textos antiguos.",
  "agora.s2.body": "Si Zeno abrió la puerta, Chrysippus construyó la casa. Cientos de tratados, casi todos perdidos, sobre cómo una impresión se convierte en un pensamiento, y un pensamiento en una acción. El estoicismo se convierte en una manera completa de ver, una lógica de cómo estar vivo.",
  "agora.s3.numeral": "VI",
  "agora.s3.title": "El puente hacia Roma",
  "agora.s3.dates": "185–51 a. C.",
  "agora.s3.figures": "Panaetius · Posidonius",
  "agora.s3.atmosphere": "Velas en el Mediterráneo. Una carga de ideas más pesada que el grano.",
  "agora.s3.body": "El estoicismo cruza las aguas. En Rodas y Roma se encuentra con el derecho romano, el deber romano, el temperamento romano. Se suaviza, se amplía, se vuelve práctico. Para cuando llega al suelo del Senado, ya no es solo griego. Es una manera de ser ciudadano.",
  "agora.s4.numeral": "VII",
  "agora.s4.title": "El patio de Séneca",
  "agora.s4.dates": "4 a. C. – 65 d. C.",
  "agora.s4.themes": "Tiempo · Riqueza · Amistad · Mortalidad",
  "agora.s4.atmosphere": "El jardín de una villa romana. Una fuente. Olivos. Una carta a medio escribir sobre la mesa.",
  "agora.s4.body": "Preceptor de un emperador, consejero en el centro del poder y, finalmente, condenado por él. Séneca escribe como un hombre que sabe que se le pedirá morir antes de que termine el año. Sus cartas a Lucilio son cálidas, casi domésticas, y serenas ante todo. Siguen siendo lo más cercano que tiene la filosofía a un amigo mayor y sabio.",
  "agora.s5.numeral": "VIII",
  "agora.s5.title": "Epicteto",
  "agora.s5.dates": "50 – 135 d. C.",
  "agora.s5.themes": "Libertad · Dominio de sí · Prohairesis · La ciudadela interior",
  "agora.s5.atmosphere": "Una habitación sencilla. Una lámpara. Un solo banco. No hace falta nada más.",
  "agora.s5.body": "Nacido esclavo, cojo de por vida, desterrado por un emperador y, sin embargo, la mente más libre de su tiempo. Epicteto enseña que nadie fuera de nosotros gobierna lo que más propiamente nos pertenece: el uso que hacemos de nuestras impresiones. La doctrina de la prohairesis, la facultad interior de elegir, se convierte en el corazón de la práctica.",
  "agora.s6.numeral": "IX",
  "agora.s6.title": "Marco en el Danubio",
  "agora.s6.dates": "121 – 180 d. C.",
  "agora.s6.subtitle": "El emperador que escribió para sí mismo",
  "agora.s6.atmosphere": "Una tienda militar en la frontera del Danubio. La hora dorada. Una fogata afuera. Una lámpara de aceite adentro. El peso del imperio, y un solo cuaderno abierto sobre una mesa de madera.",
  "agora.s6.body": "Nunca quiso que leyéramos estas páginas. Las Meditaciones son ejercicios privados: un hombre que practica, a la luz de una vela, cómo seguir siendo justo bajo una presión injusta, cómo mantener la mano abierta cuando el mundo exige un puño cerrado. El hombre más poderoso del mundo, la mayoría de las noches, simplemente intentaba ser uno mejor.",
  "agora.s6.pull": "Comience la mañana diciéndose a sí mismo: hoy me encontraré con el entrometido, el ingrato…",
  "agora.s7.numeral": "XII",
  "agora.s7.title": "La Biblioteca",
  "agora.s7.atmosphere": "Una larga sala clásica. Estanterías hasta el techo abovedado. Mesas de lectura de madera oscura. Silencio.",
  "agora.s7.body": "Un futuro hogar para textos, cursos, ejercicios, reflexiones y los libros que han dado forma a la práctica. Por ahora, las estanterías se están llenando.",
  "agora.s7.shelf1": "Textos",
  "agora.s7.shelf2": "Cursos",
  "agora.s7.shelf3": "Ejercicios",
  "agora.s7.shelf4": "Reflexiones",
  "agora.s7.shelf5": "Recomendaciones de libros",
  "agora.s8.numeral": "XIII",
  "agora.s8.title": "La sala de la luz",
  "agora.s8.atmosphere": "Una sala abierta. Piedra blanca. Ventanas altas. Largos haces de luz dorada de la tarde cruzando el suelo.",
  "agora.s8.line1": "El conocimiento puede almacenarse.",
  "agora.s8.line2": "La información puede transmitirse.",
  "agora.s8.line3": "La inteligencia puede simularse.",
  "agora.s8.line4": "Pero la sabiduría debe vivirse.",
  "agora.s8.line5": "El carácter nos ha sostenido.",
  "agora.s8.line6": "Ahora es tiempo de sabiduría.",
  "agora.s8.line7": "El conocimiento es barato.",
  "agora.s8.line8": "La sabiduría no tiene precio.",
  "agora.s9.numeral": "XIV",
  "agora.s9.title": "La Stoa moderna",
  "agora.s9.atmosphere": "Vidrio. Piedra. Lino. Luz serena. La arquitectura de una vida en calma.",
  "agora.s9.body": "Un camino antiguo, encontrado por una vida moderna. Las preguntas ya no se plantean en un mercado de Atenas. Se plantean en una cocina a las seis de la mañana, en una reunión a las dos, en un pasillo de hospital, en el tren de regreso a casa. El estoicismo vuelve a espacios que en realidad nunca abandonó.",
  "agora.s9.topicsLabel": "Temas",
  "agora.s9.t1": "Relaciones",
  "agora.s9.t2": "Salud",
  "agora.s9.t3": "Trabajo",
  "agora.s9.t4": "Liderazgo",
  "agora.s9.t5": "Política",
  "agora.s9.t6": "Redes sociales",
  "agora.s9.t7": "Inteligencia artificial",
  "agora.s9.t8": "Sentido",
  "agora.s10.numeral": "XV",
  "agora.s10.title": "Virtue Guide",
  "agora.s10.body": "La lección termina. La práctica comienza.",
  "agora.s10.cta": "Abrir Virtue Guide",
  "agora.s10.note": "Las Guías están siempre con usted.",
  "agora.s11.numeral": "XVI",
  "agora.s11.title": "La salida",
  "agora.s11.atmosphere": "Un sendero de piedra que deja atrás la columnata. El sol, bajo. El día, más sereno de como empezó.",
  "agora.s11.line1": "Las Guías están siempre con usted.",
  "agora.s11.line2": "Hasta que usted regrese a la Naturaleza y al Logos.",
  "agora.figures.label": "Capítulos futuros",
  "agora.figures.note": "Cada figura a continuación tiene su propia sala en la Agora. Las salas ya existen; las palabras llegarán a su debido tiempo.",
  "agora.fig.zeno": "Zenón de Citio",
  "agora.fig.cleanthes": "Cleantes",
  "agora.fig.chrysippus": "Crisipo",
  "agora.fig.panaetius": "Panecio",
  "agora.fig.posidonius": "Posidonio",
  "agora.fig.seneca": "Séneca",
  "agora.fig.musonius": "Musonio Rufo",
  "agora.fig.epictetus": "Epicteto",
  "agora.fig.marcus": "Marco Aurelio",
  "agora.fig.modern": "La Stoa moderna",
  "agora.philosophy.title": "Por qué existe la Agora",
  "agora.philosophy.body": "Para preservar, cultivar y transmitir la sabiduría. La tecnología sirve a la sabiduría, no al revés. La IA puede llegar a ser la mayor biblioteca de la humanidad, pero la sabiduría sigue siendo el logro más alto de la humanidad.",
};
